import { hr as RetailerSetup } from './retailerSetup';

export default {
    CatalogWorkspace: {
        title: 'Uvoz i sinkronizacija kataloga',
        intro: 'Povežite izvor kataloga, uvezite datoteku ili upravljajte integracijama trgovine.',
        navigation: 'Uvoz i postavke kataloga',
        sources: 'Izvori i URL-ovi',
        upload: 'Ručno učitaj CSV',
        stores: 'Integracije trgovina',
        scraper: 'Custom scraper',
        categories: 'Mapiranje kategorija',
        sourceHelp: 'Dodajte URL kataloga, pregledajte uzorak i potvrdite mapiranje prije prvog synca.',
        uploadHelp: 'Uvezite CSV datoteku za početno punjenje kataloga ili jednokratno ažuriranje.',
        storesHelp: 'Upravljajte povezanim trgovinama i njihovim sigurnim integracijama.',
        categoriesHelp: 'Pregledajte i potvrdite kako su kategorije iz feeda povezane s DigiWarranty kategorijama.',
        scraperTitle: 'Izvor kojim upravlja custom scraper',
        scraperHelp: 'Scraper se konfigurira za konkretnu trgovinu. Ne unosite običnu web-stranicu kao CSV/XML/JSON feed. Postojeći povezani scraperi prikazuju se među vašim izvorima; dodavanje novog zahtijeva administratorsku konfiguraciju.',
    },
    RetailerSetup,
    "PluginConnect": {
        "loading": "Učitavanje sigurne veze...",
        "unavailable": "Povezivanje nije dostupno",
        "incomplete": "Link za povezivanje nije potpun.",
        "expired": "Sesija za povezivanje nije dostupna ili je istekla.",
        "failed": "Trgovinu nije bilo moguće povezati. Pokušajte ponovo.",
        "title": "Povežite {{platform}} trgovinu",
        "intro": "Pregledajte i odobrite organizaciju koja će biti vlasnik ove integracije.",
        "store": "Trgovina",
        "website": "Web-stranica",
        "catalog": "Katalog",
        "catalogValue": "{{products}} proizvoda, {{discounts}} popusta",
        "noOrganization": "Nije pronađena odgovarajuća organizacija",
        "noOrganizationHelp": "Ako ste se upravo registrovali, potvrdite email i prijavite se da nastavite povezivanje. Vaš račun mora biti administrator organizacije.",
        "organization": "Organizacija",
        "venue": "Naziv online prodajnog mjesta",
        "venueName": "Naziv novog online prodajnog mjesta",
        "createVenue": "Kreirajte novo online prodajno mjesto",
        "permissions": "DigiWarranty će moći:",
        "permissionCatalog": "Sinkronizirati proizvode, cijene, zalihe i aktivne popuste",
        "permissionReceipts": "Slati račune samo kada kupac to odabere",
        "permissionVenue": "Koristiti postojeće online prodajno mjesto ili napraviti novo za ovu {{platform}} trgovinu",
        "consent": "Odobravam povezivanje ove {{platform}} trgovine s organizacijom {{organization}}.",
        "security": "Sigurna jednokratna autorizacija",
        "connecting": "Povezivanje...",
        "connect": "Poveži trgovinu"
    },
    "Add Condition": "Add Condition",
    "Add Incentive": "Add Incentive",
    "Add Strategy": "Add Strategy",
    "Add Target": "Add Target",
    "AdminNav": {
        "organizationApprovals": "Zahtjevi za registraciju",
        "categoryMapping": "Mapiranje kategorija",
        "dashboard": "Nadzorna ploča",
        "organizations": "Organizacije",
        "promotionTypes": "Vrste promocija",
        "scannedBills": "Skenirani računi",
        "users": "Korisnici",
        "customers": "Kupci",
        "venues": "Lokacije",
        "cities": "Gradovi",
        "scraperStaging": "Scraper Staging",
        "catalogOperations": "Katalog i enrichment",
        "alerts": "Upozorenja",
        "notifications": "Obavijesti",
        "giveaways": "Nagradne igre",
        "globalPointsSettings": "Postavke globalnih bodova",
        "freshness": "Svježina podataka",
        "transactions": "Transakcije",
        "revenue": "Prihod",
        "billingProfiles": "Naplata profili",
        "planOffers": "Planovi i posebne ponude",
        "bills": "Računi",
        "invoices": "Fakture",
        "contracts": "Ugovori",
        "reconciliation": "Usklađivanje",
        "integrations": "Integracije",
        "integrationLogs": "Logovi integracija",
        "integrationSync": "Sinkronizacija integracija",
        "integrationQuotas": "Kvote integracija"
    },
    "AdminNavGroups": {
        "cmsRules": "CMS i Pravila",
        "identity": "Identitet i Tenanti",
        "operations": "Operacije",
        "overview": "Pregled"
    },
    "AuthorizedServices": {
        "addService": "Dodaj novi servis",
        "address": "Address",
        "cancel": "Odustani",
        "create": "Kreiraj",
        "createService": "Kreiraj ovlašteni servis",
        "name": "Name",
        "noServices": "Nema dostupnih ovlaštenih servisa.",
        "overview": "Pregled ovlaštenih servisnih centara",
        "phone": "Phone",
        "serviceAddress": "Adresa servisa",
        "serviceName": "Naziv servisa",
        "servicePhone": "Telefon servisa",
        "title": "Title"
    },
    "Back": "Back",
    "BillApprovalDetail": {
        "alreadyApproved": "This bill has been approved",
        "alreadyRejected": "This bill has been rejected",
        "approvalWarning": "Approving this bill will create an official transaction record and activate warranties for the items.",
        "approve": "Approve Bill",
        "approveSuccess": "Bill approved successfully.",
        "back": "Back to approvals",
        "error": "Failed to load bill.",
        "fields": {
            "address": "Address",
            "billDate": "Bill Date",
            "billNumber": "Bill Number",
            "email": "Email",
            "name": "Name",
            "paymentMethod": "Payment Method",
            "phone": "Phone",
            "total": "Total Amount",
            "venueName": "Venue Name"
        },
        "items": {
            "price": "Price",
            "product": "Product",
            "quantity": "Qty",
            "total": "Total"
        },
        "loading": "Loading bill...",
        "noItems": "No items on this bill.",
        "notFound": "Bill not found.",
        "notesPlaceholder": "Add any notes about this review...",
        "processing": "Processing...",
        "reject": "Reject Bill",
        "rejectModal": {
            "cancel": "Cancel",
            "confirm": "Confirm Rejection",
            "description": "Please select a reason for rejecting this bill.",
            "reasons": {
                "duplicate": "Duplicate submission",
                "invalidReceipt": "Invalid or illegible receipt",
                "itemsMismatch": "Items do not match receipt",
                "other": "Other reason",
                "unreadable": "Cannot read bill details",
                "wrongStore": "Receipt is not from our store"
            },
            "selectReason": "Select a reason...",
            "title": "Reject Bill"
        },
        "rejectSuccess": "Bill rejected successfully.",
        "rejectionReason": "Rejection Reason",
        "reviewNotes": "Review Notes",
        "reviewedAt": "Reviewed at",
        "sections": {
            "billDetails": "Bill Details",
            "customer": "Customer Information",
            "images": "Bill Images",
            "items": "Items",
            "reviewNotes": "Review Notes",
            "venue": "Venue"
        },
        "title": "Bill Review",
        "virtualProduct": "Virtual",
        "virtualVenue": "Virtual Venue"
    },
    "BillApprovals": {
        "actions": {
            "view": "View"
        },
        "columns": {
            "actions": "Actions",
            "billNumber": "Bill #",
            "customer": "Customer",
            "date": "Date",
            "items": "Items",
            "status": "Status",
            "total": "Total",
            "venue": "Venue"
        },
        "empty": {
            "description": "All bills have been reviewed. New bills will appear here when customers submit them.",
            "title": "No pending approvals"
        },
        "error": "Failed to load bills.",
        "filters": {
            "all": "All",
            "status": "Status"
        },
        "loading": "Loading bills...",
        "stats": {
            "approved": "Approved",
            "pending": "Pending",
            "rejected": "Rejected",
            "thisWeek": "This Week"
        },
        "status": {
            "approved": "Approved",
            "pending": "Pending",
            "rejected": "Rejected"
        },
        "subtitle": "Review and approve bills submitted by customers for your stores.",
        "title": "Bill Approvals"
    },
    "Calculation": "Calculation",
    "Campaign Details": "Campaign Details",
    "Campaign Wizard": "Campaign Wizard",
    "Campaign updated successfully!": "Campaign updated successfully!",
    "Campaigns": {
        "CampaignCreate": {
            "budget": "Proračun",
            "cancel": "Odustani",
            "createCampaign": "Kreiraj kampanju",
            "creating": "Kreiranje...",
            "description": "Opis",
            "endDate": "Datum završetka",
            "error": "Error",
            "goalDescription": "Opis cilja",
            "loading": "Kreiranje kampanje...",
            "name": "Naziv kampanje",
            "startDate": "Datum početka",
            "title": "Kreiraj novu kampanju"
        },
        "CampaignEdit": {
            "Tutorial": {
                "addPromotionInstruction": "Koristite gumb 'Dodaj promociju' za stvaranje nove promocije.",
                "campaignSettingsMessage": "U ovom odjeljku možete konfigurirati osnovne postavke svoje kampanje.",
                "campaignSettingsTitle": "Pregled postavki kampanje",
                "conditionsInstruction1": "Možete dodati više uvjeta za promociju.",
                "conditionsInstruction2": "Osigurajte da su uvjeti ispunjeni prije nego što promocija krene.",
                "conditionsMessage": "Uvjeti su pravila koja određuju kada je promocija aktivna.",
                "conditionsTitle": "Uvjeti",
                "incentivesInstruction1": "Razmotrite koji će poticaji biti najprivlačniji vašoj publici.",
                "incentivesInstruction2": "Možete ponuditi više vrsta poticaja za svaku promociju.",
                "incentivesMessage": "Poticaji su pogodnosti koje nudite kako biste potaknuli sudjelovanje kupaca.",
                "incentivesTitle": "Poticaji",
                "promotionEditInstruction": "Kliknite na promociju da biste uredili njezine detalje.",
                "promotionsListMessage": "Ovaj odjeljak prikazuje sve promocije povezane s vašom kampanjom.",
                "promotionsListTitle": "Popis promocija",
                "schedulesInstruction1": "Postavite datume početka i završetka za svoje promocije.",
                "schedulesInstruction2": "Prilagodite svoje rasporede na temelju izvedbe kampanje.",
                "schedulesMessage": "Rasporedi određuju vrijeme vaših promocija.",
                "schedulesTitle": "Rasporedi",
                "strategiesInstruction1": "Možete dodati više strategija za promociju.",
                "strategiesInstruction2": "Odaberite najbolje strategije na temelju ciljeva svoje kampanje.",
                "strategiesMessage": "Strategije definiraju kako će se promocija provoditi.",
                "strategiesTitle": "Strategije",
                "targetsInstruction1": "Pažljivo definirajte svoju ciljnu publiku.",
                "targetsInstruction2": "Možete dodati više ciljeva za svaku promociju.",
                "targetsMessage": "Ciljevi su segmenti publike koje želite dosegnuti svojom promocijom.",
                "targetsTitle": "Ciljevi",
                "tutorialTitle": "Upute za uređivanje kampanje",
                "welcomeMessage": "Dobrodošli u upute za uređivanje kampanje! Ovdje ćete naučiti kako učinkovito upravljati svojim kampanjama."
            },
            "analysisTab": "Analiziraj Kampanju",
            "backToCampaigns": "Natrag na kampanje",
            "breakdown": "Razrada Kampanje",
            "budget": "Proračun",
            "calculate": "Izračunaj",
            "calculationSuccess": "Calculation Success",
            "calculations": "Analiza i Preporuke",
            "clickCalculate": "Kliknite 'Izračunaj' za prikaz rezultata analize.",
            "clickCalculatePlaceholder": "Kliknite \"Izračunaj\" za prikaz rezultata analize.",
            "description": "Opis",
            "editCampaignTitle": "Uredi Kampanju",
            "editTab": "Edituj Kampanju",
            "endDate": "Datum Zatvaranja",
            "failedCalculation": "Neuspjeh u izračunu podataka kampanje",
            "failedLoad": "Failed Load",
            "failedUpdate": "Neuspjeh u ažuriranju kampanje",
            "generalDetails": "Opće informacije",
            "goalDescription": "Opis Cilja",
            "initialReach": "Početni Dohvat",
            "initialReachPromotion": "Početni Dohvat: {value}",
            "managePromotions": "Upravljajte svojim promocijama",
            "name": "Naziv Kampanje",
            "noSuggestions": "Nema dostupnih preporuka.",
            "noSuggestionsAvailable": "Nema dostupnih preporuka.",
            "placeholderBudget": "Unesite proračun kampanje",
            "placeholderDescription": "Unesite opis kampanje",
            "placeholderEndDate": "Odaberite datum zatvaranja",
            "placeholderGoalDescription": "Unesite opis cilja kampanje",
            "placeholderName": "Unesite naziv kampanje",
            "placeholderStartDate": "Odaberite datum početka",
            "price": "Cijena",
            "priceStrategy": "Strategija {index} (Tip: {type}) Cijena: ${price}",
            "prices": "Cijene",
            "pricesLabel": "Cijene",
            "promotion": "Promocija",
            "promotionLabel": "Promocija {index}",
            "promotionsTab": "Edituj Promociju",
            "reach": "Dohvat",
            "reaches": "Dohvati",
            "revenue": "Prihod",
            "saving": "Spremanje...",
            "startDate": "Datum Početka",
            "strategy": "Strategija",
            "strategyReach": "Strategija {index} (Tip: {type}) Dohvat: {value}",
            "successUpdate": "Kampanja je uspješno ažurirana",
            "suggestions": "Preporuke",
            "suggestionsForPromotion": "Preporuke za Promociju {index}:",
            "target": "Dohvat Cilja {index}",
            "timelineAndBudget": "Vremenski okvir i proračun",
            "totalBudget": "Ukupni proračun",
            "type": "Tip",
            "updateCampaign": "Ažuriraj Kampanju",
            "welcomeMessage": "Dobrodošli na stranicu za Uređivanje Kampanje!"
        },
        "PromotionEdit": {
            "addCondition": "Dodaj uvjet",
            "addIncentive": "Dodaj poticaj",
            "addStrategy": "Dodaj strategiju",
            "addTarget": "Dodaj cilj",
            "basicInformation": "Osnovne informacije",
            "conditions": "Uvjeti({{count}})",
            "editOverlay": "Uredi overlay",
            "editPromotion": "Uredi promociju: {{promotionName}}",
            "incentives": "Incentivi({{count}})",
            "promotionName": "Promocija",
            "promotionOverlay": "Overlay promocije",
            "strategies": "Strategije({{count}})",
            "targets": "Ciljevi({{count}})"
        },
        "PromotionList": {
            "addPromotion": "Dodaj Promociju",
            "promotion": "Promocija {{index}}",
            "promotionsList": "Popis Promocija"
        },
        "PromotionWizard": {
            "conditions": "Conditions",
            "finish": "Finish",
            "incentives": "Incentives",
            "next": "Next",
            "previous": "Previous",
            "settings": "Settings",
            "stepIndicator": "Step Indicator",
            "strategies": "Strategies",
            "targets": "Targets",
            "title": "Title"
        },
        "Tutorial": {
            "createCampaignMessage": "Ovdje možete kreirati novu kampanju prema vašim poslovnim potrebama.",
            "createCampaignTitle": "Kreiraj novu kampanju",
            "manageCampaignsMessage": "U ovom dijelu možete pregledavati, uređivati i brisati svoje postojeće kampanje. Koristite pretraživač za brzo pronalaženje određene kampanje.",
            "manageCampaignsTitle": "Upravljajte svojim kampanjama",
            "tutorialMessage": "Ovaj tutorial će vas voditi kroz proces učinkovito upravljanje kampanjama.",
            "tutorialTitle": "Tutorial za kampanje",
            "welcomeMessage": "Dobrodošli u upravljanje kampanjama!"
        },
        "actions": "Akcije",
        "addNew": "Dodaj novu kampanju",
        "budget": "Proračun",
        "calculating": "Izračunavanje...",
        "delete": "Izbriši",
        "deleteConfirm": "Jeste li sigurni da želite obrisati ovu kampanju?",
        "deleteError": "Neuspješno brisanje kampanje.",
        "deleteSuccess": "Kampanja je uspješno obrisana.",
        "deleteTitle": "Obriši kampanju",
        "description": "Opis",
        "edit": "Uredi",
        "emptyDescription": "Kreirajte svoju prvu kampanju za početak praćenja rezultata.",
        "emptyTitle": "Još nema kampanja",
        "endDate": "Datum završetka",
        "goalDescription": "Opis cilja",
        "loadError": "Neuspješno učitavanje kampanja.",
        "name": "Ime",
        "noWarranties": "Nema pronađenih kampanja.",
        "saving": "Spremanje...",
        "search": "Pretraži kampanje...",
        "startDate": "Datum početka",
        "title": "Kampanje"
    },
    "Common": {
        "search": "Search",
        "actions": "Actions",
        "active": "Active",
        "address": "Address",
        "all": "All",
        "back": "Back",
        "cancel": "Cancel",
        "change": "Change",
        "city": "City",
        "country": "Country",
        "date": "Date",
        "delete": "Delete",
        "edit": "Edit",
        "email": "Email",
        "extracted": "Extracted",
        "items": "Items",
        "key": "Key",
        "manufacturer": "Manufacturer",
        "name": "Name",
        "no": "No",
        "open": "Open",
        "phone": "Phone",
        "product": "Product",
        "real": "Real",
        "refresh": "Refresh",
        "required": "Required",
        "retailer": "Retailer",
        "rows": "Rows",
        "save": "Save",
        "saveChanges": "Save Changes",
        "select": "Select",
        "selected": "Selected",
        "surname": "Surname",
        "total": "Total",
        "user": "User",
        "venue": "Venue",
        "virtual": "Virtual",
        "yes": "Yes",
        "hide": "Hide",
        "inactive": "Inactive",
        "loading": "Loading",
        "notAvailable": "Not Available",
        "show": "Show"
    },
    "Condition Name": "Condition Name",
    "Conditions": "Conditions",
    "Criteria": "Criteria",
    "CrossSellEarnings": {
        "chart": {
            "commission": "Provizija",
            "purchase": "Iznos kupovine",
            "title": "Performanse cross-sell zarade",
            "transactions": "Transakcije"
        },
        "errors": {
            "generic": "Nije moguće učitati cross-sell zaradu. Pokušajte ponovno."
        },
        "table": {
            "columns": {
                "averageCommission": "Prosj. provizija %",
                "commission": "Provizija",
                "fees": "Naknade",
                "period": "Razdoblje",
                "purchase": "Iznos kupovine",
                "sellers": "Prodavatelji",
                "transactions": "Transakcije"
            },
            "empty": "Nema cross-sell podataka za ovo razdoblje.",
            "title": "Pregled po razdoblju"
        },
        "title": "Cross-sell zarada",
        "totals": {
            "averageCommission": "Prosječna provizija %",
            "distinctSellers": "Različiti prodavatelji",
            "totalCommission": "Zarađena provizija",
            "totalFee": "Transakcijske naknade",
            "totalPurchase": "Vrijednost cross-sell kupovina",
            "totalTransactions": "Cross-sell transakcije"
        },
        "view": {
            "daily": "Dnevno",
            "monthly": "Mjesečno"
        }
    },
    "Dashboard": {
        "Tutorial": {
            "explanation_message": "Ova nadzorna ploča prikazuje statistiku vaše organizacije od dana registracije. Možete prilagoditi prikaz prema svojim željama.",
            "explanation_title": "Pregled",
            "title": "Upute za nadzornu ploču"
        },
        "average_revenue_per_user": "Prosječni prihod po korisniku",
        "average_selling_transaction_value": "Prosječna vrijednost prodajne transakcije",
        "activeDiscounts": "Aktivni popusti",
        "availableProducts": "Dostupni proizvodi",
        "belonging_users_count": "Broj pripadajućih korisnika",
        "campaigns_count": "Broj kampanja",
        "catalogProducts": "Proizvodi u katalogu",
        "catalogClicks": "Klikovi na katalog · 30 dana",
        "catalogDetailViews": "Otvaranja detalja kataloga · 30 dana",
        "catalogImpressions": "Prikazi kataloga · 30 dana",
        "catalogSync": "Sinkronizacija kataloga",
        "discountClicks": "Klikovi na ponudu trgovca · 30 dana",
        "discountDetailViews": "Otvaranja detalja popusta · 30 dana",
        "discountImpressions": "Prikazi popusta · 30 dana",
        "error": "Pogreška pri učitavanju podataka nadzorne ploče",
        "loading": "Učitavanje...",
        "manufacturer_count": "Broj proizvođača",
        "manageCatalog": "Upravljaj katalogom",
        "noSyncYet": "Sinkronizacija kataloga još nije pokrenuta.",
        "revenue_value": "Vrijednost prihoda",
        "selling_transactions_count": "Broj prodajnih transakcija",
        "setup_add_address_cta": "Dodaj adresu",
        "setup_add_address_desc": "Dodajte poslovnu lokaciju i podatke o državi.",
        "setup_add_address_title": "Dovršite adresu tvrtke",
        "setup_add_billing_email_cta": "Dodaj e-mail za naplatu",
        "setup_add_billing_email_desc": "Osigurajte da računi stižu na ispravan inbox.",
        "setup_add_billing_email_title": "Dodajte e-mail za naplatu",
        "setup_add_contact_cta": "Dodaj kontakte",
        "setup_add_contact_desc": "Unesite e-mail i broj telefona za podršku i naplatu.",
        "setup_add_contact_title": "Dodajte kontakt podatke",
        "setup_add_description_cta": "Dodaj opis",
        "setup_add_description_desc": "Recite partnerima i korisnicima čime se bavite.",
        "setup_add_description_title": "Dodajte opis tvrtke",
        "setup_add_venue_cta": "Kreiraj lokaciju",
        "setup_add_venue_desc": "Dodajte lokaciju kako biste mogli uvoziti proizvode.",
        "setup_add_venue_title": "Kreirajte prvu lokaciju",
        "setup_add_website_cta": "Dodaj web",
        "setup_add_website_desc": "Podijelite službenu web stranicu s korisnicima i partnerima.",
        "setup_add_website_title": "Dodajte web stranicu",
        "setup_complete_description": "Podaci o tvrtki su postavljeni. Aktivnosti će se prikazati ovdje kada počnete koristiti DigiWarranty.",
        "setup_complete_title": "Sve je spremno",
        "setup_loyalty_points_cta": "Postavi bodove",
        "setup_loyalty_points_desc": "Odredite koliko bodova kupci zaraduju po kupnji.",
        "setup_loyalty_points_title": "Postavite bodove vjernosti",
        "setup_set_localization_cta": "Postavi lokalizaciju",
        "setup_set_localization_desc": "Odaberite valutu, vremensku zonu i jezik za izvještaje.",
        "setup_set_localization_title": "Postavite lokalizaciju",
        "setup_intro": "Dodajte osnovne podatke za početak. Ostalo možete dovršiti kasnije.",
        "setup_next": "Preporučeni sljedeći korak",
        "setup_other_steps": "Prikaži još {{count}} koraka",
        "setup_remaining": "Preostalo koraka: {{count}}",
        "setup_title": "Pripremite svoju tvrtku",
        "retailerOverview": "Pregled trgovine",
        "retailerOverviewDescription": "Katalog, aktivni popusti i interes kupaca na jednom mjestu.",
        "syncCreated": "Dodano: {{count}}",
        "syncErrors": "Problemi: {{count}}",
        "syncStatus_failed": "Posljednja sinkronizacija nije uspjela",
        "syncStatus_ok": "Posljednja sinkronizacija uspješno završena",
        "syncStatus_partial": "Sinkronizacija završena uz nekoliko problema",
        "syncStatus_queued": "Sinkronizacija je u redu čekanja",
        "syncStatus_running": "Sinkronizacija je u tijeku",
        "syncStatus_skipped": "Posljednja sinkronizacija je preskočena",
        "syncStatus_timeout": "Isteklo je vrijeme za sinkronizaciju",
        "syncStatus_unknown": "Status sinkronizacije nije dostupan",
        "syncUpdated": "Ažurirano: {{count}}",
        "unlimited": "Neograničeno",
        "viewAnalytics": "Otvori statistiku",
        "setup_upload_logo_cta": "Dodaj logotip",
        "setup_upload_logo_desc": "Dodajte logotip kako bi se brend prikazivao u cijelom sustavu.",
        "setup_upload_logo_title": "Dodajte logotip tvrtke",
        "sold_items_count": "Broj prodanih artikala",
        "title": "Nadzorna ploča",
        "total_transaction_volume": "Ukupni obujam transakcija",
        "users_count": "Broj korisnika",
        "venues_count": "Broj lokacija"
    },
    "DistributorBestOffers": {
        "empty": "No manufacturer incentives are live right now.",
        "error": "Unable to load incentives.",
        "subtitle": "See which manufacturers are subsidizing your outbound pipeline this week.",
        "title": "Manufacturer incentives",
        "validUntil": "Valid until {{end}}"
    },
    "DistributorDashboard": {
        "error": "Unable to load distributor dashboard.",
        "insights": {
            "actionItems": "Action Items",
            "noActions": "No pending actions",
            "topManufacturers": "Top Manufacturers",
            "topRegions": "Top Regions",
            "topRetailers": "Top Retailers"
        },
        "inventory": {
            "copy": "Aggregated stock across every distributor hub.",
            "inboundQuantity": "Inbound quantity",
            "outboundQuantity": "Outbound quantity",
            "title": "Warehouse capacity"
        },
        "loading": "Loading distributor metrics...",
        "metrics": {
            "activeManufacturers": "Active Manufacturers",
            "activeRetailers": "Active Retailers",
            "activeVenues": "Active Logistics Hubs",
            "averageFulfillmentTime": "Avg. Fulfillment Time",
            "campaignsSupported": "Campaigns Supported",
            "inboundQuantity": "Inbound Quantity",
            "inboundValue": "Inbound Value",
            "integrationAlerts": "Integration Alerts",
            "inventoryOnHand": "Inventory On Hand",
            "openSupportCases": "Open Support Cases",
            "orderFillRate": "Order Fill Rate",
            "outboundQuantity": "Outbound Quantity",
            "outboundValue": "Outbound Value",
            "returnsRate": "Returns Rate",
            "skuPortfolio": "SKU Portfolio"
        },
        "sections": {
            "flow": {
                "copy": "Track the movement of units across inbound and outbound lanes, along with fulfillment pace.",
                "title": "Flow performance"
            },
            "health": {
                "copy": "Quality signals such as returns, support workload, integration alerts, and joint campaigns.",
                "title": "Reliability & engagement"
            },
            "network": {
                "copy": "How many partners, venues, and SKUs you actively touch today.",
                "title": "Channel coverage"
            }
        },
        "title": "Distributor Dashboard"
    },
    "DistributorDiscounts": {
        "empty": "No distributor discounts recorded yet.",
        "error": "Unable to load distributor discounts.",
        "filters": {
            "all": "All"
        },
        "importButton": "Import discounts CSV",
        "importSoon": "CSV import will be available soon.",
        "subtitle": "Manage the promotions you extend to retailers across venues.",
        "summary": {
            "active": "Active",
            "expired": "Expired",
            "upcoming": "Upcoming"
        },
        "table": {
            "discount": "Discount",
            "end": "Valid until",
            "global": "All venues",
            "product": "Product",
            "status": "Status",
            "venue": "Venue"
        },
        "title": "Distributor discounts"
    },
    "DistributorImportExport": {
        "actions": {
            "startExport": "Queue export",
            "startImport": "Queue import",
            "submitting": "Submitting..."
        },
        "error": "Unable to load import/export jobs.",
        "exports": {
            "requestSubtitle": "Generate downstream packages for your brands and retailers.",
            "requestTitle": "Schedule export"
        },
        "form": {
            "fileName": "File name (optional)",
            "sourceName": "Source name",
            "sourceUrl": "Source URL",
            "type": "Type"
        },
        "history": {
            "exports": "Export history",
            "imports": "Import history"
        },
        "imports": {
            "requestSubtitle": "Pull SKU, warranty, or retailer updates via CSV/JSON.",
            "requestTitle": "Start new import"
        },
        "loading": "Loading jobs...",
        "subtitle": "Sync SKU catalogs, warranty templates, and retailer lists with partners.",
        "table": {
            "date": "Date",
            "download": "Download",
            "file": "File",
            "progress": "Progress",
            "source": "Source",
            "status": "Status",
            "type": "Type"
        },
        "tabs": {
            "exports": "Exports",
            "imports": "Imports"
        },
        "title": "Imports & Exports",
        "toast": {
            "error": "Unable to complete the request",
            "exportCreated": "Export requested",
            "importCreated": "Import queued"
        }
    },
    "DistributorIntegrations": {
        "actions": {
            "add": "Add connector",
            "cancel": "Cancel",
            "confirmDelete": "Remove this connector?",
            "save": "Save",
            "saving": "Saving..."
        },
        "addTitle": "Add connector",
        "detail": {
            "apiKey": "API key",
            "apiSecret": "API secret (copy now)",
            "endpoint": "API endpoint",
            "sync": "Sync interval",
            "type": "Connector type",
            "webhookSecret": "Webhook secret",
            "webhookUrl": "Webhook URL"
        },
        "editTitle": "Edit connector",
        "empty": "Select a connector to see details.",
        "error": "Unable to load integrations.",
        "form": {
            "custom": "Custom",
            "email": "Contact email",
            "endpoint": "Endpoint URL",
            "isActive": "Integration active",
            "name": "Name",
            "sync": "Sync interval",
            "syncDaily": "Daily",
            "syncHourly": "Hourly",
            "syncRealtime": "Real time",
            "type": "Type",
            "webhook": "Webhook URL"
        },
        "loading": "Loading integrations...",
        "stats": {
            "active": "Active",
            "total": "Total connectors",
            "webhook": "Webhook alerts"
        },
        "subtitle": "Connect ERP/POS stacks, rotate API keys, and monitor webhooks.",
        "table": {
            "actions": "Actions",
            "lastSync": "Last sync",
            "name": "Connector",
            "never": "Never",
            "status": "Sync",
            "type": "Type",
            "webhook": "Webhook"
        },
        "title": "Distributor integrations",
        "toast": {
            "created": "Connector created",
            "deleted": "Connector deleted",
            "error": "Unable to process request",
            "secret": "Copy the API secret now — it is only shown once",
            "token": "Rotated API credentials",
            "updated": "Connector updated",
            "webhook": "Webhook test recorded"
        }
    },
    "DistributorManufacturerDetail": {
        "activity": {
            "inbound": "Inbound",
            "outbound": "Outbound"
        },
        "back": "Back to manufacturers",
        "empty": "No data yet.",
        "error": "Unable to load manufacturer detail.",
        "loading": "Loading manufacturer detail…",
        "metrics": {
            "activeRetailers": "Active retailers",
            "inboundQuantity": "Inbound units",
            "inboundValue": "Inbound value",
            "outboundQuantity": "Outbound units",
            "outboundValue": "Outbound value"
        },
        "recentActivity": "Recent activity",
        "subtitle": "No description provided",
        "topRetailers": "Top retailers"
    },
    "DistributorManufacturers": {
        "error": "Unable to load manufacturers.",
        "list": {
            "title": "Manufacturer overview"
        },
        "loading": "Loading manufacturers...",
        "pagination": {
            "next": "Next",
            "prev": "Prev"
        },
        "periodOption": {
            "last_7_days": "Last 7 days",
            "this_month": "This month",
            "this_quarter": "This quarter",
            "this_year": "This year"
        },
        "searchPlaceholder": "Search manufacturers…",
        "stats": {
            "inboundValue": "Inbound value",
            "outboundValue": "Outbound value",
            "totalManufacturers": "Total linked manufacturers"
        },
        "subtitle": "Monitor connected brands, inbound supply, and sell-through performance.",
        "table": {
            "count": "{{count}} total",
            "inbound": "Inbound",
            "manufacturer": "Manufacturer",
            "outbound": "Outbound",
            "retailers": "Active retailers",
            "title": "Manufacturers",
            "units": "{{count}} units",
            "view": "View"
        },
        "title": "Partner manufacturers"
    },
    "DistributorNav": {
        "manufacturers": "Manufacturers",
        "retailers": "Retailers"
    },
    "DistributorRetailerDetail": {
        "back": "Back to retailers",
        "empty": "No data yet.",
        "error": "Unable to load retailer detail.",
        "loading": "Loading retailer detail…",
        "manufacturers": "Manufacturers & categories",
        "metrics": {
            "manufacturers": "Linked manufacturers",
            "outboundQuantity": "Outbound units",
            "outboundValue": "Outbound value"
        },
        "recentOrders": "Recent orders",
        "subtitle": "No description provided"
    },
    "DistributorRetailers": {
        "error": "Unable to load retailers.",
        "graph": {
            "allRetailers": "All retailers",
            "error": "Unable to load timeline data.",
            "noData": "No timeline data yet.",
            "period": "Period",
            "periodOption": {
                "last_7_days": "Last 7 days",
                "this_month": "This month",
                "this_quarter": "This quarter",
                "this_year": "This year",
                "yesterday": "Yesterday"
            },
            "retailers": "Retailers"
        },
        "list": {
            "title": "Retailer overview"
        },
        "loading": "Loading retailers...",
        "pagination": {
            "next": "Next",
            "prev": "Prev"
        },
        "searchPlaceholder": "Search retailers…",
        "stats": {
            "outboundQuantity": "Outbound units",
            "outboundValue": "Outbound value",
            "totalRetailers": "Total retailers"
        },
        "subtitle": "Understand which retailers rely on you for each brand/category.",
        "table": {
            "allCategories": "All categories",
            "categories": "Categories",
            "count": "{{count}} total",
            "manufacturers": "Manufacturers",
            "outbound": "Outbound",
            "retailer": "Retailer",
            "title": "Retailers",
            "units": "{{count}} units",
            "view": "View"
        },
        "tabs": {
            "graph": "Timeline",
            "list": "Overview"
        },
        "title": "Retail partners"
    },
    "DistributorSettings": {
        "actions": {
            "addContact": "Add contact",
            "remove": "Remove",
            "rotateToken": "Rotate token",
            "save": "Save settings",
            "saving": "Saving..."
        },
        "api": {
            "active": "API enabled",
            "key": "Current API key",
            "none": "Not generated",
            "secret": "New API secret (copy now)",
            "subtitle": "Manage credentials used by upstream manufacturers.",
            "title": "API tokens"
        },
        "branding": {
            "logo": "Logo URL",
            "primary": "Primary color",
            "secondary": "Secondary color",
            "subtitle": "Align portal colors and contact info with your brand.",
            "supportEmail": "Support email",
            "supportPhone": "Support phone",
            "title": "Branding & support"
        },
        "error": "Unable to load distributor settings.",
        "escalation": {
            "contactEmail": "Email",
            "contactName": "Contact name",
            "contactPhone": "Phone",
            "contacts": "Escalation contacts",
            "policy": "Escalation policy",
            "sla": "Target SLA (hours)",
            "slaPlaceholder": "e.g., 24",
            "subtitle": "Control who is paged when retailers raise incidents.",
            "title": "Escalation policy & SLA"
        },
        "loading": "Loading settings...",
        "subtitle": "Adjust escalation rules, branding, and API access.",
        "title": "Distributor settings",
        "toast": {
            "error": "Unable to save settings",
            "saved": "Settings saved",
            "token": "Generated new API token"
        }
    },
    "DistributorTransactions": {
        "cards": {
            "inbound": "Inbound value",
            "manufacturers": "Manufacturers",
            "outbound": "Outbound value",
            "retailers": "Retailers",
            "transactions": "Transactions",
            "units": "{{count}} units",
            "venues": "Venues"
        },
        "errors": {
            "loadDemographics": "Unable to load transaction statistics.",
            "loadProgress": "Unable to load progress data.",
            "loadStats": "Unable to load distributor transactions."
        },
        "progress": {
            "current": "Current period",
            "outbound": "Outbound comparison",
            "previous": "Previous period"
        },
        "statistics": {
            "empty": "No retailer insights yet.",
            "regions": "Retailer regions",
            "topRetailers": "Top retailer mix",
            "venues": "Venue contribution"
        },
        "subtitle": "Monitor inbound vs outbound value across manufacturers, retailers, and venues.",
        "table": {
            "columns": {
                "date": "Date",
                "inboundValue": "Inbound value",
                "manufacturer": "Manufacturer",
                "outboundValue": "Outbound value",
                "retailer": "Retailer",
                "transactions": "Transactions",
                "venue": "Venue"
            }
        },
        "title": "Distributor transactions"
    },
    "DistributorVenueDetail": {
        "back": "Back to Venues",
        "error": "Unable to load venue detail.",
        "loading": "Loading venue detail...",
        "stats": {
            "outbound": "Outbound value",
            "units": "units"
        },
        "subtitle": "Performance overview for {{city}} hub",
        "topItems": {
            "empty": "No items shipped yet.",
            "metrics": "{{quantity}} units • {{value}}",
            "title": "Top items"
        }
    },
    "DistributorVenues": {
        "errors": {
            "loadList": "Unable to load venues."
        },
        "subtitle": "Track downstream locations supplied by your network.",
        "table": {
            "columns": {
                "action": "Action",
                "lastActivity": "Last activity",
                "location": "Location",
                "outboundValue": "Outbound value",
                "retailer": "Retailer",
                "venue": "Venue"
            },
            "count": "{{count}} total",
            "search": "Search venues...",
            "view": "Open"
        },
        "title": "Distributor Venues"
    },
    "Edit Campaign Details": "Edit Campaign Details",
    "Imports": {
        "fieldMappingIntro": "Povezali smo stupce iz CSV datoteke s poljima kataloga. Provjerite obavezna polja prije nastavka.",
        "fieldMappingRequiredTitle": "Osnovni podaci",
        "fieldMappingRequiredHelp": "Naziv, cijena i poveznica proizvoda obavezni su za svaki proizvod.",
        "fieldMappingIdentifierTitle": "Identifikator proizvoda",
        "fieldMappingIdentifierHelp": "Povežite barem jedan identifikator, primjerice SKU, EAN ili ID iz vašeg sustava. Ostale možete ostaviti praznima.",
        "fieldMappingRequiredCount": "{{mapped}} / {{total}} obaveznih povezano",
        "fieldMappingMissing": "Povežite naziv proizvoda, cijenu, poveznicu proizvoda i barem jedan identifikator (SKU, EAN ili ID proizvoda).",
        "fieldMappingAiSuggestion": "Gemini prijedlog · {{confidence}}% pouzdanosti",
        "optionalFieldsTitle": "Dodatna polja",
        "optionalFieldsCount": "{{count}} neobaveznih",
        "optionalFieldsHelp": "Povežite samo podatke koji postoje u vašoj CSV datoteci. Ostala polja možete preskočiti.",
        "searchGptCategory": "Pretražite Google Product Taxonomy…",
        "categorySearchMinChars": "Unesite najmanje 2 znaka za pretragu.",
        "categorySearchLoading": "Pretražujemo GPT kategorije…",
        "categorySearchNoResults": "Nema pronađenih kategorija.",
        "categorySearchFailed": "Pretraga nije uspjela. Provjerite vezu i pokušajte ponovo.",
        "categorySearchClear": "Ukloni odabranu kategoriju",
        "wizard": {
            "title": "Koraci uvoza",
            "upload": "Učitaj CSV",
            "columns": "Provjeri stupce",
            "mappings": "Proizvođači i kategorije",
            "review": "Pregled i uvoz",
            "columnsReady": "Stupci prepoznati",
            "fileUploaded": "Datoteka učitana",
            "categorySuggestionsReady": "Gemini je predložio {{count}} kategorija. Pouzdani prijedlozi već su odabrani; pregledajte ostale i potvrdite odabir.",
            "processing": {
                "uploading": "Učitavanje CSV datoteke…",
                "fields": "Prepoznajemo stupce i pripremamo prijedloge…",
                "fieldSuggestionFailed": "Automatsko povezivanje stupaca trenutačno nije dostupno. Provjerite ih i povežite ručno.",
                "reusingMapping": "Koristimo spremljeno mapiranje i provjeravamo podatke…",
                "savingMapping": "Spremamo mapiranje stupaca…",
                "analyzing": "Analiziramo proizvode i kategorije…",
                "categories": "Pripremamo prijedloge kategorija…",
                "savingMappings": "Spremamo mapiranja proizvođača, kategorija i lokacija…",
                "startingImport": "Pokrećemo uvoz…",
                "importQueued": "CSV datoteka čeka obradu u redu.",
                "importProcessing": "CSV se obrađuje u pozadini.",
                "importProgress": "Možete ostati na ovoj stranici; napredak se automatski osvježava.",
                "importStaged": "CSV obrada je završena; stavke su u katalogu za daljnju obradu.",
                "categorySuggestionFailed": "Automatski prijedlozi kategorija nisu dostupni. Kategorije možete pronaći i povezati ručno.",
                "canContinue": "Možete nastaviti čim su obavezna polja povezana.",
                "wait": "Ovo može potrajati nekoliko trenutaka. Nemojte zatvarati ovu stranicu."
            }
        },
        "autoMatched": "poklopljeno automatski",
        "autoGoogle": "svrstano preko Google taksonomije",
        "autoPerProduct": "svrstava se po proizvodu",
        "template": {
            "title": "Predložak i upute",
            "description": "Ispunite naš predložak. Obavezna su četiri stupca, ostalo popunite ako imate — prazna ćelija ne zaustavlja uvoz.",
            "download": "Preuzmi predložak (CSV)",
            "guide": "Otvori upute",
            "required": "product_name, price, product_url te sku ili external_product_id"
        },
        "unknownColumns": "Stupce koje ne čitamo preskačemo: {{columns}}. To nije greška — vaš izvoz smije nositi i vlastite stupce.",
        "diff": {
            "title": "Što će se promijeniti",
            "subtitle": "Pregled prije nego išta uđe u katalog.",
            "newProducts": "Novih proizvoda",
            "linkingToKnown": "{{count}} se veže na artikl koji već imamo",
            "brandNew": "{{count}} je posve nov artikl",
            "existingProducts": "Već postoji",
            "priceChanges": "Promjena cijene",
            "withoutBarcode": "Bez barkoda",
            "invalid": "Neispravnih redaka",
            "newManufacturers": "Nastali bi novi proizvođači:",
            "unmappableCategories": "Kategorije koje ne možemo svrstati:",
            "invalidRows": "Redci koji neće ući",
            "priceChangeList": "Promjene cijena",
            "line": "Redak",
            "product": "Proizvod",
            "problem": "Problem",
            "from": "Sa",
            "to": "Na"
        },
        "analysisSubtitle": "Jedinstveni entiteti pronađeni u datoteci.",
        "analysisTitle": "Sažetak analize",
        "analyzeButton": "Analiziraj datoteku",
        "categories": "Kategorije",
        "categoryMapping": "Mapiranje kategorija",
        "suggestCategories": "Predloži Google kategorije pomoću Geminija",
        "suggestingCategories": "Predlažem kategorije...",
        "aiCategorySuggestionsRemaining": "Još {{count}} kategorija čeka AI prijedlog. Ponovi ovu radnju za nastavak.",
        "useAiCategorySuggestion": "Koristi ovaj prijedlog",
        "aiCategorySuggestion": "Gemini prijedlog: {{path}} ({{confidence}}%, {{status}}). Pregledaj prije spremanja.",
        "createCategory": "Kreiraj novu kategoriju",
        "createManufacturer": "Kreiraj novog proizvođača",
        "created": "Kreirano",
        "discounts": "Popusti",
        "discountMatches": {
            "matched": "Usklađeni popusti",
            "unmatched": "Neusklađeni popusti"
        },
        "discountPreview": {
            "title": "Pregled popusta",
            "row": "Red",
            "externalProductId": "Vanjski ID proizvoda",
            "sku": "SKU/GTIN",
            "percentage": "Popust %",
            "value": "Iznos popusta",
            "discountedPrice": "Snižena cijena",
            "startAt": "Početak",
            "endAt": "Kraj",
            "match": "Podudaranje",
            "matchYes": "Usklađeno",
            "matchNo": "Nije usklađeno"
        },
        "error": "Greška u uvozu",
        "failed": "Neuspješno",
        "importType": "Vrsta uvoza",
        "loading": "Učitavanje...",
        "manufacturerMapping": "Mapiranje proizvođača",
        "manufacturers": "Proizvođači",
        "mappingTitle": "Mapiranja",
        "mappingsSaved": "Mapiranja spremljena",
        "missingColumns": "Nedostajući stupci",
        "noExternalId": "Nema vanjskog ID-a",
        "none": "Nema",
        "pending": "Na čekanju",
        "processedRows": "Obrađeni redovi",
        "products": "Proizvodi",
        "progressTitle": "Napredak",
        "requiredNote": "Provjerite da CSV sadrži obvezne stupce prije uvoza.",
        "runButton": "Pokreni uvoz",
        "runSubtitleByType": {
            "catalog": "Kreiraj ili ažuriraj proizvode, cijene, zalihe i popuste iz jednog CSV-a.",
            "discounts": "Primijeni popuste na postojeće artikle u katalogu.",
            "full": "Kreiraj/ažuriraj artikle i kreiraj/ažuriraj njihove popuste.",
            "items": "Kreiraj ili ažuriraj artikle i podatke organizacijskih SKU-ova."
        },
        "runTitle": "Pokreni uvoz",
        "running": "Uvoz u tijeku...",
        "saveMappings": "Spremi mapiranja",
        "selectCategory": "Odaberite kategoriju",
        "selectManufacturer": "Odaberite proizvođača",
        "skipped": "Preskočeno",
        "status": "Status",
        "title": "Uvozi",
        "totalRows": "Ukupno redaka",
        "types": {
            "catalog": "Katalog, cijene, zalihe i popusti",
            "discounts": "Samo popusti",
            "full": "Puni uvoz (artikli + popusti)",
            "items": "Uvoz artikala",
            "products": "Uvoz proizvoda"
        },
        "columnsGuide": {
            "title": "Vodič za CSV stupce",
            "required": "Obavezno:",
            "optional": "Opcionalno:",
            "items": {
                "description": "Koristi se za uvoz podataka artikala bez kreiranja/ažuriranja popusta.",
                "required": "manufacturer_name, manufacturer_external_id, category_name, category_external_id, product_name, external_product_id, sku_or_gtin",
                "optional": "price ili regular_price, stock_quantity, description/image/metadata polja"
            },
            "full": {
                "description": "Koristi se za puni sync: kreiranje/ažuriranje artikala i kreiranje/ažuriranje popusta.",
                "required": "manufacturer_name, manufacturer_external_id, category_name, category_external_id, product_name, external_product_id, sku_or_gtin, te discount_percentage ili discount_value",
                "optional": "price ili regular_price, stock_quantity, discount_start_at, discount_end_at, description/image/metadata polja"
            },
            "discounts": {
                "description": "Koristi se samo za ažuriranje popusta. Proizvod mora već postojati u katalogu.",
                "required": "external_product_id ili sku_or_gtin, te discount_percentage ili discount_value",
                "optional": "price ili regular_price (za izračun postotka), discount_start_at, discount_end_at"
            }
        },
        "unknown": "Nepoznato",
        "updated": "Ažurirano",
        "uploadButton": "Učitaj i provjeri",
        "uploadSubtitle": "Odaberite CSV datoteku za provjeru i pregled.",
        "uploadTitle": "Učitaj CSV",
        "uploading": "Učitavanje...",
        "validationSubtitle": "Pregled otkrivenih stupaca i prvih redaka.",
        "validationTitle": "Rezultat provjere"
    },
    "Incentives": "Incentives",
    "Items": {
        "ItemDescription": {
            "description": "Opis:",
            "documentation_url": "URL dokumentacije:",
            "model_number": "Broj modela:",
            "month": "{{count}} mjesec",
            "no_description": "No description",
            "no_details": "Nema dostupnih detalja o artiklu",
            "no_technical_specifications": "Nema dostupnih tehničkih specifikacija",
            "release_year": "Godina izdanja:",
            "technical_specifications": "Tehničke specifikacije",
            "view_documentation": "Pogledajte dokumentaciju",
            "warranty_coverage": "Pokriće jamstva:",
            "warranty_duration": "Trajanje jamstva:",
            "year": "{{count}} godina"
        },
        "Overview": {
            "actions": "Akcije",
            "manufacturer_name": "Proizvođač",
            "model_number": "Broj Modela",
            "organization_sku": "SKU organizacije",
            "product_name": "Ime Proizvoda",
            "serial_number": "Serijski broj",
            "status": "Status",
            "status_in_stock": "Na stanju",
            "status_sold": "Prodano",
            "title": "Pregled Stavki",
            "variant_sku": "Varijanta SKU",
            "view": "Pregled"
        },
        "Performance": {
            "charts": {
                "brandMix": "Prihod po proizvođaču",
                "salesTrend": "Trend prodaje",
                "unitsSeries": "Prodane jedinice"
            },
            "emptyState": "Nema podataka za odabrani period.",
            "subtitle": "Pratite koliko se brzo artikli kreću iz zalihe prema korisnicima.",
            "summary": {
                "atRiskSkus": "Rizični SKU-ovi",
                "avgDaysOnShelf": "Prosj. dani na polici",
                "avgSellingPrice": "Prosj. prodajna cijena",
                "stockOnHand": "Stanje zaliha",
                "totalRevenue": "Ostvareni prihod",
                "totalUnits": "Prodane jedinice"
            },
            "tables": {
                "columns": {
                    "item": "Artikl",
                    "lastSold": "Posljednja prodaja",
                    "manufacturer": "Proizvođač",
                    "revenue": "Prihod",
                    "stock": "Zaliha",
                    "units": "Jedinice"
                },
                "slowMovers": "Spori artikli na zalihi",
                "topSellers": "Najprodavaniji"
            },
            "title": "Uvidi o performansama"
        },
        "SearchFilters": {
            "search_button": "Pretraži",
            "search_placeholder": "Pretraži po broju modela, serijskom broju ili imenu proizvoda",
            "select_manufacturer": "Odaberi Proizvođača"
        },
        "TransactionsTable": {
            "buyer": "Kupac",
            "counterparty": "Druga strana",
            "counterparty_from": "Od",
            "counterparty_to": "Za",
            "date": "Datum",
            "direction_bought": "Kupljeno od strane organizacije",
            "direction_sold": "Prodano od strane organizacije",
            "n_a": "Nema",
            "no_transactions": "Nema transakcija",
            "of": "od",
            "page": "Stranica",
            "payment_method": "Način Plačanja",
            "price": "Cijena",
            "price_paid": "Plaćeno",
            "quantity": "Količina",
            "revenue": "Prihod",
            "rows_per_page": "Redova po stranici",
            "sale_value": "Prodajna vrijednost",
            "shipping_cost": "Trošak Dostave",
            "title": "Transakcije za Artikl",
            "transaction_type": "Tip Transakcije",
            "venue": "Mjesto",
            "warranty": "Jamstvo"
        },
        "Tutorial": {
            "message": "Ovaj tutorial će vas provesti kroz funkcionalnosti sekcije Stavke.",
            "title": "Tutorial o Stavkama"
        },
        "ViewItem": {
            "Tutorial": {
                "tabs": {
                    "description": {
                        "message": "Pregledajte detaljne informacije o artiklu, uključujući opis, proizvođača i kategoriju.",
                        "title": "Kartica Opis"
                    },
                    "details": {
                        "message": "Istražite tehničke specifikacije, certifikate i druge detaljne informacije o artiklu.",
                        "title": "Kartica Detalji"
                    },
                    "transactions": {
                        "message": "Pogledajte sve transakcije povezane s ovim artiklom, uključujući povijest kupnje i detalje.",
                        "title": "Kartica Transakcije"
                    },
                    "warranty": {
                        "message": "Pregledajte detalje jamstva, uključujući trajanje, pokriće i postupak zahtjeva.",
                        "title": "Kartica Jamstvo"
                    }
                },
                "welcome_message": "Dobrodošli u vodič za prikaz artikla!"
            },
            "category": "Kategorija",
            "details": {
                "carbon_footprint": "Ugljični otisak",
                "category": "Kategorija",
                "certifications": "Certifikati",
                "current_price": "Trenutna cijena",
                "discount": "Popust",
                "documentation": "Dokumentacija",
                "icecat_id": "Icecat ID",
                "initial_price": "Početna cijena",
                "last_sold_price": "Zadnja prodajna cijena",
                "material_composition": "Sastav materijala",
                "model_number": "Broj modela",
                "organization_sku": "SKU organizacije",
                "recycling_instructions": "Upute za recikliranje",
                "release_year": "Godina izdanja",
                "serial_number": "Serijski broj",
                "source_id": "ID izvora",
                "start_date": "Datum početka",
                "technical_specifications": "Tehničke specifikacije",
                "variant_sku": "Varijanta SKU",
                "view_documentation": "Pogledaj dokumentaciju"
            },
            "loading": "Učitavanje detalja artikla...",
            "manufacturer": "Proizvođač",
            "tabs": {
                "description": "Opis",
                "details": "Detalji",
                "transactions": "Transakcije",
                "warranty": "Jamstvo"
            },
            "warranty": {
                "active": "Aktivno",
                "applicable_to": "Primjenjive regije",
                "claim_process": "Postupak zahtjeva",
                "contact": "Kontakt",
                "coverage": "Pokriće",
                "duration": "Trajanje",
                "exclusions": "Izuzeci",
                "name": "Naziv jamstva",
                "title": "Informacije o jamstvu"
            }
        },
        "Warranty": {
            "columns": {
                "buyer": "Kupac",
                "days": "Dani",
                "expiry": "Kraj jamstva",
                "item": "Artikl",
                "saleDate": "Datum prodaje",
                "venue": "Prodajno mjesto"
            },
            "empty": "Nema upozorenja za ovu grupu.",
            "filters": {
                "limit": "Redaka po popisu",
                "missingActivation": "Aktivacija nije zabilježena (dani)",
                "refresh": "Osvježi",
                "withinDays": "Praćenje (dani)"
            },
            "labels": {
                "daysOverdue": "{{count}} dana kašnjenja",
                "daysRemaining": "još {{count}} dana"
            },
            "sections": {
                "expired": {
                    "description": "Artikli kojima je jamstvo već isteklo.",
                    "title": "Istekla jamstva"
                },
                "expiringSoon": {
                    "description": "Jamstva koja završavaju u sljedećih {{days}} dana.",
                    "title": "Uskoro istječu"
                },
                "missingActivation": {
                    "description": "Artikli prodani u zadnjih {{days}} dana bez zabilježene aktivacije.",
                    "title": "Bez aktivacije"
                }
            },
            "subtitle": "Uočite rizična jamstva prije nego što se korisnici jave podršci.",
            "summary": {
                "expired": "Istekla",
                "expiringSoon": "Uskoro istječu",
                "missingActivation": "Bez aktivacije"
            },
            "title": "Upozorenja na jamstvo"
        },
        "overview": "Pregled Stavki",
        "performance_insights": "Uvidi U Performanse",
        "title": "Stavke",
        "warranty_alerts": "Upozorenja na Jamstvo"
    },
    "LoginPage": {
        "Tutorial": {
            "about_app": "Ova aplikacija je osmišljena kako bi pojednostavila upravljanje programima lojalnosti za maloprodaju integrirajući digitalne garancije za kupljene artikle i olakšavajući upravljanje kampanjama za promocije. Nudi snažne analitičke alate koji pomažu korisnicima da učinkovito prate tržišne trendove. Konsolidacijom upravljanja bodovima, popustima i garancijama u jedinstvenu platformu, korisnici mogu eliminirati poteškoće s rukovanjem papirnatim garancijama i računima. Ovaj inovativni pristup osigurava neometano iskustvo, omogućujući kupcima da lako upravljaju svojim nagradama za lojalnost i informacijama o garanciji—sve unutar jedne praktične aplikacije.",
            "about_app_title": "O aplikaciji",
            "credentials_title": "Demo Login Podaci",
            "demo_credentials": "Za testiranje možete koristiti: \n - E-mail: organization1@dwm.com, Lozinka: password \n - E-mail: organization2@dwm.com, Lozinka: password. \nOrganizacija 1 ima 6 tisuća korisnika, a organizacija 2 ima 4 tisuće korisnika, simulirajući interakciju korisnika između dvije organizacije.",
            "development_message": "Ukoliko vidite ovu ikonu to znaci da je ova funkcija trenutno u razvoju.",
            "info_message": "Ako se ikada osjećate izgubljeno ili nešto ne razumijete, kliknite na ikonu info kako biste pronašli objašnjenje svake stranice i segmenta.",
            "info_title": "Informacije",
            "question_message": "Ako imate bilo kakva pitanja o sustavu ili ovoj stranici, slobodno kliknite na ikonu upitnika i pošaljite svoje pitanje. Netko će vam se uskoro javiti.",
            "question_title": "Imate pitanja?",
            "welcome_message": "Dobrodošli u demo našeg sustava! Slobodno istražite i iskusite sve funkcionalnosti koje smo implementirali.",
            "welcome_title": "Dobrodošli u GSOFT Demo!"
        },
        "email_label": "E-mail",
        "forgot_password": "Zaboravljena lozinka",
        "login_button": "Prijavi se",
        "login_error": "Prijava nije uspjela. Provjerite e-mail i lozinku.",
        "or_continue_with": "ili nastavi s",
        "no_account": "Nemate račun?",
        "password_label": "Lozinka",
        "register": "Registracija",
        "subtitle": "Pristupite jamstvima, lojalnosti i analitici jednim prijavljivanjem.",
        "title": "Dobrodošli nazad"
    },
    "ManufacturerCompliance": {
        "actions": {
            "add": "Dodaj dokument",
            "cancel": "Odustani",
            "confirmDelete": "Obrisati dokument?",
            "edit": "Uredi",
            "save": "Spremi",
            "saving": "Spremanje...",
            "share": "Podijeli"
        },
        "alerts": {
            "expiring": "{{count}} dokument(a) ističe unutar 30 dana"
        },
        "error": "Dokumenti se ne mogu učitati.",
        "form": {
            "description": "Opis",
            "expires": "Datum isteka",
            "file": "URL datoteke",
            "title": "Naslov",
            "type": "Tip dokumenta"
        },
        "loading": "Učitavanje dokumenata...",
        "share": {
            "description": "Unesite e-mailove odvojene zarezom.",
            "placeholder": "partner@example.com",
            "title": "Podijeli dokument"
        },
        "status": {
            "draft": "Nacrt",
            "shared": "Podijeljeno"
        },
        "subtitle": "Pratite DPP pakete, regulatorne dokumente i rokove.",
        "table": {
            "actions": "Radnje",
            "doc": "Dokument",
            "expires": "Ističe",
            "status": "Status",
            "type": "Tip"
        },
        "title": "Usklađenost i certifikati",
        "toast": {
            "created": "Dokument dodan",
            "deleted": "Dokument obrisan",
            "error": "Radnja nije uspjela",
            "shared": "Dokument podijeljen",
            "updated": "Dokument ažuriran"
        },
        "types": {
            "certificate": "Certifikat",
            "dpp": "DPP",
            "regulatory": "Regulatorno"
        }
    },
    "ManufacturerDashboard": {
        "actions": "Preporučene akcije",
        "activeDistributors": "Aktivni distributeri",
        "activeRetailers": "Aktivni trgovci",
        "activeWarranties": "Aktivne garancije",
        "avgSellThrough": "Prosječna vrijednost Sell-Through",
        "avgTtr": "Prosječno vrijeme popravka",
        "campaignsRunning": "Aktivne kampanje",
        "error": "Nije moguće učitati podatke za proizvođača.",
        "loading": "Učitavanje statistike proizvođača...",
        "noActions": "Nema hitnih radnji.",
        "openTickets": "Otvoreni servisni ticketi",
        "returns": "Povrati",
        "returnsRate": "Stopa povrata",
        "sellIn": "Sell-In vrijednost",
        "sellInQuantity": "Sell-In jedinice",
        "sellInTransactions": "Sell-In transakcije",
        "sellThrough": "Sell-Through vrijednost",
        "sellThroughQuantity": "Sell-Through jedinice",
        "sellThroughRate": "Stopa Sell-Through",
        "sellThroughTransactions": "Sell-Through transakcije",
        "title": "Proizvođačka nadzorna ploča",
        "topBuyers": "Top kupci",
        "topRetailerRegions": "Top regije (trgovci)",
        "topRetailers": "Top trgovci",
        "topSkus": "Top SKU-ovi",
        "topUserRegions": "Top regije (kupci)",
        "totalSkus": "Ukupno SKU-ova",
        "uniqueBuyers": "Jedinstveni kupci",
        "warrantyActivation": "Stopa aktivacije garancije"
    },
    "ManufacturerDiscounts": {
        "empty": "No manufacturer discounts recorded yet.",
        "error": "Unable to load manufacturer discounts.",
        "filters": {
            "all": "All"
        },
        "importButton": "Import discounts CSV",
        "importSoon": "CSV import will be available soon.",
        "subtitle": "Review incentives deployed to distributors and retailers worldwide.",
        "summary": {
            "active": "Active",
            "expired": "Expired",
            "upcoming": "Upcoming"
        },
        "table": {
            "discount": "Discount",
            "end": "Valid until",
            "global": "All venues",
            "product": "Product",
            "status": "Status",
            "venue": "Venue"
        },
        "title": "Manufacturer discounts"
    },
    "ManufacturerDistributorDetail": {
        "activity": {
            "columns": {
                "date": "Datum",
                "direction": "Smjer",
                "quantity": "Količina",
                "value": "Vrijednost"
            },
            "direction": {
                "inbound": "Ulaz od proizvođača",
                "outbound": "Izlaz prema partnerima"
            },
            "empty": "Nema nedavnih transakcija.",
            "title": "Nedavna aktivnost"
        },
        "back": "Natrag na distributere",
        "contact": {
            "notAvailable": "Nije dostupno",
            "title": "Kontakt podaci"
        },
        "error": "Nije moguće učitati podatke o distributeru.",
        "loading": "Učitavanje podataka o distributeru...",
        "stats": {
            "inbound": "Ulazne kupnje",
            "inventory": "Jedinice u kanalu",
            "outbound": "Izlazne prodaje",
            "sold": "Prodane jedinice",
            "units": "jedinica",
            "venues": "Lokacije"
        },
        "subtitle": "Potpuni uvid u odnos s ovim distributerom.",
        "venues": {
            "empty": "Još nema povezanih lokacija.",
            "title": "Lokacije"
        }
    },
    "ManufacturerDistributors": {
        "errors": {
            "loadList": "Nije moguće učitati distributere.",
            "loadStats": "Nije moguće učitati analitiku distributera."
        },
        "stats": {
            "cards": {
                "distributors": "Aktivni distributeri",
                "inbound": "Ulazna vrijednost",
                "inventory": "Jedinice u kanalu",
                "outbound": "Izlazna vrijednost",
                "sold": "Prodane jedinice",
                "venues": "Povezane lokacije"
            },
            "countries": {
                "empty": "Nema dostupnih država.",
                "title": "Top države"
            },
            "error": "Nije moguće učitati analitiku distributera.",
            "loading": "Učitavanje analitike distributera...",
            "trend": {
                "empty": "Nema zabilježenog prometa ovaj tjedan.",
                "inbound": "Ulaz",
                "outbound": "Izlaz",
                "title": "Trend vrijednosti (EUR)"
            }
        },
        "subtitle": "Pratite uzvodne partnere, pokrivenost i snagu kanala.",
        "table": {
            "columns": {
                "action": "Radnja",
                "country": "Država",
                "distributor": "Distributer",
                "inbound": "Ulazna vrijednost",
                "inventory": "Jedinice u kanalu",
                "outbound": "Izlazna vrijednost",
                "sold": "Prodane jedinice",
                "venues": "Lokacije"
            },
            "notAvailable": "N/A",
            "search": "Pretraži distributere...",
            "view": "Otvori"
        },
        "tabs": {
            "list": "Popis",
            "stats": "Analitika"
        },
        "title": "Distributeri"
    },
    "ManufacturerImportExport": {
        "actions": {
            "startExport": "Pokreni export",
            "startImport": "Pokreni import",
            "submitting": "Slanje..."
        },
        "error": "Ne mogu se učitati import/export zadaci.",
        "exports": {
            "requestSubtitle": "Generirajte datoteke za povezane sustave.",
            "requestTitle": "Zatraži export"
        },
        "form": {
            "fileName": "Naziv datoteke",
            "sourceName": "Naziv izvora",
            "sourceUrl": "URL izvora",
            "type": "Tip"
        },
        "history": {
            "exports": "Povijest exportova",
            "imports": "Povijest importova"
        },
        "imports": {
            "requestSubtitle": "Pošaljite CSV/JSON putem sigurnog linka.",
            "requestTitle": "Pokreni import"
        },
        "loading": "Učitavanje zadataka...",
        "status": {
            "completed": "Dovršeno",
            "failed": "Neuspjelo",
            "pending": "Na čekanju",
            "processing": "Obrada"
        },
        "subtitle": "Upravljajte SKU katalozima, garancijama i mapiranjima distributera.",
        "table": {
            "date": "Datum",
            "download": "Preuzmi",
            "file": "Datoteka",
            "progress": "Napredak",
            "source": "Izvor",
            "status": "Status",
            "type": "Tip"
        },
        "tabs": {
            "exports": "Exporti",
            "imports": "Importi"
        },
        "title": "Import/Export centar",
        "toast": {
            "error": "Radnja nije uspjela",
            "exportCreated": "Export zatražen",
            "importCreated": "Import pokrenut"
        },
        "types": {
            "distributor": "Mapiranja distributera",
            "sku": "SKU katalog",
            "warranty": "Predlošci garancija"
        }
    },
    "ManufacturerIntegrations": {
        "actions": {
            "add": "Dodaj konektor",
            "cancel": "Odustani",
            "confirmDelete": "Obrisati ovaj konektor?",
            "save": "Spremi",
            "saving": "Spremanje...",
            "testWebhook": "Testiraj webhook"
        },
        "addTitle": "Dodaj konektor",
        "detail": {
            "apiKey": "API ključ",
            "apiSecret": "API tajna (kopirajte odmah)",
            "endpoint": "API endpoint",
            "sync": "Interval sinkronizacije",
            "type": "Vrsta konektora",
            "webhookSecret": "Webhook tajna",
            "webhookUrl": "Webhook URL"
        },
        "editTitle": "Uredi konektor",
        "error": "Integracije nije moguće učitati.",
        "form": {
            "custom": "Prilagođeno",
            "email": "Kontakt email",
            "endpoint": "Endpoint URL",
            "isActive": "Integracija aktivna",
            "name": "Naziv",
            "sync": "Interval",
            "syncDaily": "Dnevno",
            "syncHourly": "Svaki sat",
            "syncRealtime": "U stvarnom vremenu",
            "type": "Vrsta",
            "webhook": "Webhook URL"
        },
        "loading": "Učitavanje integracija...",
        "stats": {
            "active": "Aktivni",
            "total": "Ukupno konektora",
            "webhook": "Webhook upozorenja"
        },
        "status": {
            "healthy": "Zdravo",
            "inactive": "Neaktivno",
            "stale": "Zastarjelo",
            "warning": "Upozorenje"
        },
        "subtitle": "Povežite ERP/POS/CRM sustave i pratite webhookove te vjerodajnice.",
        "table": {
            "actions": "Radnje",
            "lastSync": "Zadnja sinkronizacija",
            "name": "Konektor",
            "never": "Nikad",
            "status": "Status",
            "type": "Vrsta",
            "webhook": "Webhook"
        },
        "title": "Integracije",
        "toast": {
            "created": "Konektor dodan",
            "deleted": "Konektor obrisan",
            "error": "Radnja nije uspjela",
            "secret": "API tajna se prikazuje samo jednom",
            "token": "API vjerodajnice su obnovljene",
            "updated": "Konektor ažuriran",
            "webhook": "Webhook test zabilježen"
        },
        "webhook": {
            "failing": "Neuspješno",
            "healthy": "Zdravo",
            "missing": "Nedostaje",
            "stale": "Zastarjelo",
            "unknown": "Nepoznato"
        }
    },
    "ManufacturerNav": {
        "compliance": "Usklađenost",
        "dashboard": "Nadzorna ploča",
        "distributors": "Distributeri",
        "imports": "Import/Export",
        "integrations": "Integracije",
        "logout": "Odjava",
        "products": "Proizvodi",
        "retailers": "Trgovci",
        "settings": "Postavke",
        "support": "Podrška",
        "transactions": "Transactions",
        "venues": "Venues",
        "warranties": "Warranties"
    },
    "ManufacturerProducts": {
        "create": {
            "cancel": "Odustani",
            "fields": {
                "description": "Opis",
                "documentation_url": "URL dokumentacije",
                "initial_price": "Početna cijena (€)",
                "model_number": "Model",
                "product_name": "Naziv proizvoda",
                "release_year": "Godina izlaska",
                "warranty_coverage": "Pokrivenost jamstva",
                "warranty_duration": "Jamstvo (mj.)"
            },
            "save": "Spremi",
            "saving": "Spremanje...",
            "title": "Kreiraj proizvod"
        },
        "detail": {
            "back": "Natrag",
            "cards": {
                "sellInUnits": "Sell-In jedinice",
                "sellInValue": "Sell-In vrijednost",
                "sellThroughUnits": "Sell-Through jedinice",
                "sellThroughValue": "Sell-Through vrijednost"
            },
            "identifierSku": "SKU",
            "identifierType": "Tip",
            "identifierValue": "Vrijednost",
            "identifiers": "Identifikatori",
            "insights": "Pregled prodaje",
            "noIdentifiers": "Još nema identifikatora.",
            "noTransactions": "Nema transakcija u periodu.",
            "noVariants": "Još nema varijanti.",
            "periodNote": "Filtrirano prema periodu",
            "sellInSeries": "Sell-In količina",
            "sellThroughSeries": "Sell-Through količina",
            "topBuyers": "Top kupci",
            "topRetailerRegions": "Top regije (trgovci)",
            "topRetailers": "Top trgovci",
            "topUserRegions": "Top regije (kupci)",
            "transactions": "Transakcije",
            "transactions_customers": "Kupci",
            "transactions_distributors": "Distributeri",
            "transactions_retailers": "Trgovci",
            "units": "{{count}} jedinica",
            "variantAttributes": "Atributi",
            "variantModel": "Model",
            "variantSku": "SKU",
            "variants": "Varijante"
        },
        "errors": {
            "createFailed": "Neuspjelo kreiranje proizvoda.",
            "fetchFailed": "Nije moguće učitati proizvode."
        },
        "newProduct": "Novi proizvod",
        "notifications": {
            "created": "Proizvod je kreiran."
        },
        "searchPlaceholder": "Traži po SKU ili nazivu...",
        "subtitle": "Upravljajte SKU-ovima i pratite prodaju.",
        "table": {
            "columns": {
                "actions": "Akcije",
                "product": "Proizvod",
                "sellIn": "Sell-In jedinice",
                "sellThrough": "Sell-Through jedinice",
                "sellThroughValue": "Sell-Through vrijednost",
                "sku": "SKU"
            },
            "view": "Detalji"
        },
        "tabs": {
            "catalog": "Katalog",
            "transactions": "Transakcije"
        },
        "title": "Katalog proizvoda",
        "transactions": {
            "customers": "Kupci",
            "retailers": "Trgovci",
            "subtitle": "Sell-in i sell-through prema periodu.",
            "title": "Transakcije proizvođača"
        }
    },
    "ManufacturerRetailerDetail": {
        "back": "Back to Retailers",
        "contact": {
            "notAvailable": "Not provided",
            "title": "Contacts & HQ"
        },
        "error": "Unable to load retailer detail.",
        "items": {
            "columns": {
                "product": "Product",
                "purchased": "Purchased",
                "sku": "SKU",
                "sold": "Sold"
            },
            "empty": "No transactions recorded for this retailer.",
            "title": "Manufacturer items performance"
        },
        "loading": "Loading retailer detail...",
        "stats": {
            "buyValue": "Buy value",
            "inventory": "Units in stock",
            "sellValue": "Sell value",
            "sold": "Units sold",
            "units": "units"
        },
        "subtitle": "Full visibility into this retailer relationship.",
        "venues": {
            "empty": "No venues connected.",
            "title": "Venues"
        }
    },
    "ManufacturerRetailers": {
        "errors": {
            "loadGraph": "Unable to load graph data.",
            "loadList": "Unable to load retailers."
        },
        "graph": {
            "allRetailers": "All retailers",
            "buyLabel": "Retailers Buy",
            "noData": "No activity recorded for the selected filters.",
            "period": "Period",
            "periodOption": {
                "last_7_days": "Last 7 days",
                "this_month": "This Month",
                "this_quarter": "This Quarter",
                "this_year": "This Year",
                "yesterday": "Yesterday"
            },
            "retailers": "Retailers",
            "sellLabel": "Retailers Sell"
        },
        "subtitle": "Monitor who buys from you, how they perform, and drill into transaction trends.",
        "table": {
            "columns": {
                "action": "Action",
                "inventory": "Units in stock",
                "retailer": "Retailer",
                "sellInValue": "Buy value",
                "sellThroughValue": "Sell value",
                "sold": "Units sold",
                "venues": "Venues"
            },
            "search": "Search retailers...",
            "view": "Open"
        },
        "tabs": {
            "graph": "Retailers Graph",
            "list": "Retailers",
            "venues": "Venues"
        },
        "title": "Retail partners",
        "venues": {
            "columns": {
                "lastActivity": "Last activity",
                "location": "Location",
                "retailer": "Retailer",
                "sellThroughValue": "Sell-through value",
                "venue": "Venue"
            },
            "errors": {
                "loadList": "Unable to load retailer venues."
            },
            "search": "Search venues or retailers..."
        }
    },
    "ManufacturerSettings": {
        "actions": {
            "add": "Dodaj",
            "addContact": "Dodaj kontakt",
            "remove": "Ukloni",
            "rotateToken": "Generiraj novi token",
            "save": "Spremi postavke",
            "saving": "Spremanje..."
        },
        "api": {
            "active": "API aktivan",
            "key": "Trenutni API ključ",
            "none": "Nije generirano",
            "secret": "Novi API secret (kopirajte sada)",
            "subtitle": "Upravljajte pristupnim podacima za integracije.",
            "title": "API tokeni"
        },
        "branding": {
            "logo": "URL logotipa",
            "primary": "Primarna boja",
            "secondary": "Sekundarna boja",
            "subtitle": "Uskladite boje i kontakt podatke s brendom.",
            "supportEmail": "E-mail podrške",
            "supportPhone": "Telefon podrške",
            "title": "Branding i podrška"
        },
        "error": "Nije moguće učitati postavke.",
        "escalation": {
            "contactEmail": "E-mail",
            "contactName": "Ime",
            "contactPhone": "Telefon",
            "contacts": "Kontakti za eskalaciju",
            "policy": "Politika eskalacije",
            "sla": "Ciljani SLA (sati)",
            "slaPlaceholder": "npr. 24",
            "subtitle": "Odredite tko prima obavijest i u kojem roku odgovarate.",
            "title": "Politika eskalacije i SLA"
        },
        "loading": "Učitavanje postavki...",
        "subtitle": "Upravljajte eskalacijama, SLA-ovima, brendom i API pristupom.",
        "title": "Postavke proizvođača",
        "toast": {
            "error": "Spremanje nije uspjelo",
            "saved": "Postavke spremljene",
            "token": "Generiran je novi API token"
        }
    },
    "ManufacturerSupport": {
        "errors": {
            "loadClaims": "Unable to load claims.",
            "loadStats": "Unable to load support stats.",
            "updateClaim": "Unable to update claim."
        },
        "filters": {
            "allStatuses": "All statuses",
            "searchPlaceholder": "Search claims..."
        },
        "notifications": {
            "statusUpdated": "Claim status updated."
        },
        "stats": {
            "avgResolution": "Avg. resolution",
            "days": "days",
            "open": "Open claims",
            "resolved": "Resolved"
        },
        "status": {
            "inProgress": "In progress",
            "resolved": "Resolved",
            "submitted": "Submitted"
        },
        "subtitle": "Track warranty claims, assignments, and service center performance.",
        "table": {
            "claim": "Claim",
            "claimDate": "Claim date",
            "item": "Item",
            "serial": "Serial",
            "status": "Status"
        },
        "title": "Support & Claims"
    },
    "ManufacturerTransactions": {
        "cards": {
            "buyers": "Distinct buyers",
            "retailers": "Retail partners",
            "sellIn": "Sell-in value",
            "sellThrough": "Sell-through value",
            "transactions": "Transactions",
            "units": "{{count}} units",
            "venues": "Active venues"
        },
        "errors": {
            "loadDemographics": "Unable to load statistics.",
            "loadProgress": "Unable to load progress data.",
            "loadStats": "Unable to load transactions."
        },
        "progress": {
            "current": "Current period",
            "previous": "Previous period",
            "sellThrough": "Sell-through comparison"
        },
        "statistics": {
            "age": "Buyer age groups",
            "buyers": "Buyers",
            "countries": "Buyer countries",
            "gender": "Buyer gender distribution",
            "venues": "Venue contribution"
        },
        "subtitle": "Analyze sell-in vs sell-through across retailers, venues, and SKUs.",
        "table": {
            "columns": {
                "date": "Date",
                "retailer": "Retailer",
                "sellInValue": "Sell-in value",
                "sellThroughValue": "Sell-through value",
                "transactions": "Transactions",
                "venue": "Venue"
            }
        },
        "tabs": {
            "overview": "Overview",
            "progress": "Progress",
            "statistics": "Statistics"
        },
        "title": "Transactions"
    },
    "ManufacturerVenueDetail": {
        "back": "Back to Venues",
        "contact": {
            "title": "Contact & location"
        },
        "error": "Unable to load venue detail.",
        "lastActivity": "Last activity: {{date}}",
        "loading": "Loading venue detail...",
        "stats": {
            "sellIn": "Sell-in value",
            "sellThrough": "Sell-through value",
            "units": "units"
        },
        "subtitle": "Performance overview for {{city}} showroom",
        "topItems": {
            "empty": "No items sold yet.",
            "metrics": "{{sell}} units • {{value}}",
            "title": "Top items"
        }
    },
    "ManufacturerVenues": {
        "create": {
            "button": "New Venue",
            "cancel": "Cancel",
            "error": "Unable to create venue.",
            "errors": {
                "nameRequired": "Name is required."
            },
            "fields": {
                "address": "Address",
                "city": "City",
                "description": "Description",
                "email": "Email",
                "name": "Venue name",
                "phone": "Phone",
                "website": "Website"
            },
            "save": "Create Venue",
            "saving": "Saving...",
            "success": "Venue created successfully.",
            "title": "Add Venue"
        },
        "errors": {
            "loadList": "Unable to load venues."
        },
        "subtitle": "Manage your own venue footprint and monitor sell-through per location.",
        "table": {
            "columns": {
                "action": "Action",
                "lastActivity": "Last activity",
                "location": "Location",
                "sellThroughValue": "Sell-through value",
                "venue": "Venue"
            },
            "search": "Search venues...",
            "view": "Open"
        },
        "title": "Manufacturer Venues"
    },
    "ManufacturerWarranties": {
        "actions": {
            "newTemplate": "New template"
        },
        "active": {
            "activated": "Activated",
            "buyer": "Buyer",
            "expires": "Expires",
            "item": "Item",
            "serial": "Serial"
        },
        "confirmDelete": "Delete this template?",
        "errors": {
            "deleteTemplate": "Unable to delete template.",
            "loadActive": "Unable to load active warranties.",
            "loadFormMeta": "Unable to load form data.",
            "loadStats": "Unable to load warranty stats.",
            "loadTemplates": "Unable to load templates.",
            "saveTemplate": "Unable to save template."
        },
        "modal": {
            "createTitle": "Create warranty template",
            "editTitle": "Edit warranty template",
            "fields": {
                "active": "Active",
                "anyItem": "Any item",
                "category": "Category",
                "claimProcess": "Claim process (one per line)",
                "description": "Description",
                "duration": "Duration (months)",
                "item": "Specific SKU",
                "name": "Name",
                "terms": "Terms (one per line)",
                "type": "Template type"
            }
        },
        "notifications": {
            "created": "Template created.",
            "deleted": "Template deleted.",
            "updated": "Template updated."
        },
        "stats": {
            "active": "Active warranties",
            "expiring": "Expiring (30d)",
            "templates": "Templates"
        },
        "subtitle": "Define warranty templates and track active coverage for your products.",
        "table": {
            "actions": "Actions",
            "duration": "Duration",
            "months": "months",
            "searchPlaceholder": "Search templates...",
            "status": "Status",
            "template": "Template",
            "type": "Type"
        },
        "tabs": {
            "active": "Active warranties",
            "templates": "Templates"
        },
        "title": "Warranties"
    },
    "Approvals": {
        "title": "Zahtjevi za registraciju",
        "refresh": "Osvježi",
        "empty": "Nema zahtjeva na čekanju.",
        "company": "Tvrtka",
        "status": "Status",
        "status_pending": "Čeka potvrdu e-maila",
        "status_verified": "E-mail potvrđen",
        "requestedType": "Traženi tip",
        "requestedPlan": "Traženi plan",
        "taxId": "OIB / VAT",
        "registered": "Registrirano",
        "approve": "Odobri",
        "reject": "Odbij",
        "cancel": "Odustani",
        "plan": "Plan",
        "confirmType": "Potvrdi tip",
        "typeHint": "Registrant tip samo deklarira. Proizvođač i distributer nose ovlasti, pa ih potvrđujemo ručno.",
        "taxVerified": "OIB je provjeren",
        "reason": "Razlog odbijanja",
        "reasonPlaceholder": "npr. OIB ne odgovara nazivu tvrtke",
        "reasonHint": "Razlog je obavezan — bez njega odbijenica završi kao upit podršci.",
        "reasonRequired": "Upišite razlog odbijanja.",
        "approved": "Registracija je odobrena.",
        "rejected": "Registracija je odbijena.",
        "actionFailed": "Radnju nije bilo moguće izvršiti.",
        "loadFailed": "Zahtjeve trenutno nije moguće dohvatiti."
    },
    "VerifyEmail": {
        "approved_title": "E-mail je potvrđen",
        "approved_message": "Račun je aktiviran. Možete se prijaviti i povezati svoj katalog.",
        "verified_title": "E-mail je potvrđen",
        "verified_message": "Hvala, adresa je potvrđena.",
        "awaiting_review_title": "E-mail je potvrđen",
        "awaiting_review_message": "Registraciju pregledavamo i javljamo se e-mailom, obično isti radni dan.",
        "invalid_title": "Link nije valjan",
        "invalid_message": "Link je istekao ili je već iskorišten. Zatražite novu poruku za potvrdu.",
        "toLogin": "Prijava"
    },
    "CatalogSources": {
        "mapping": "Mapiranje polja",
        "mappingHint": "Povežite polja iz feeda s našima. Prepoznata polja su unaprijed predložena; AI prijedlog je opcionalan i svako mapiranje možete izmijeniti prije spremanja.",
        "notMapped": "— nije mapirano —",
        "identityRequired": "Mapirajte barem jedan stabilan izvorni ID, SKU ili GTIN/EAN/UPC. Bez barkoda proizvod može u obradu ako ima stabilan ID ili SKU.",
        "aiMappingAction": "Predloži mapiranje pomoću AI-ja",
        "aiMappingRunning": "AI analizira polja…",
        "aiMappingReady": "AI prijedlog je spreman ({{count}} polja). Pregledajte ga prije spremanja.",
        "aiMappingFailed": "AI prijedlog mapiranja nije uspio.",
        "field_ean": "EAN / barkod",
        "field_external_id": "Vanjska šifra proizvoda",
        "field_parent_external_id": "Vanjska šifra nadređenog proizvoda",
        "field_external_variant_id": "Vanjska šifra varijante",
        "field_sku": "SKU",
        "field_product_name": "Naziv proizvoda",
        "field_manufacturer_name": "Proizvođač",
        "field_category_name": "Kategorija",
        "field_price": "Cijena",
        "field_sale_price": "Snižena cijena",
        "field_discount_percentage": "Popust (%)",
        "field_discount_value": "Iznos popusta",
        "field_discount_start_at": "Početak popusta",
        "field_discount_end_at": "Kraj popusta",
        "field_currency": "Valuta",
        "field_stock": "Zaliha",
        "field_stock_status": "Status dostupnosti",
        "field_url": "Poveznica",
        "field_image_url": "Slika",
        "field_warranty_months": "Jamstvo (mjeseci)",
        "title": "Izvori kataloga",
        "add": "Dodaj izvor",
        "edit": "Uredi",
        "updated": "Izvor je ažuriran.",
        "managedByPlugin": "Upravlja plugin",
        "empty": "Još nema izvora. Dodajte feed i katalog se sinkronizira automatski.",
        "adapter": "Tip izvora",
        "name": "Naziv",
        "defaultName": "Izvor kataloga",
        "frequency": "Učestalost",
        "frequencyHint": "Vaš plan dopušta do {{max}}× dnevno.",
        "runAt": "Tačna vremena",
        "runAtHint": "Opcionalno, odvojeno zarezom, npr. 08:00, 16:00.",
        "planLocked": "traži viši plan",
        "perDay": "{{n}}× dnevno",
        "test": "Testiraj konekciju",
        "testing": "Testiram…",
        "testOk": "Feed je pročitan — pronađeno {{total}} proizvoda.",
        "testFailed": "Feed nije moguće pročitati.",
        "testFirst": "Testirajte konekciju prije spremanja — tako odmah vidite što smo pročitali.",
        "detectedFields": "Pronađena polja",
        "sample": "Uzorak",
        "save": "Spremi",
        "cancel": "Odustani",
        "created": "Izvor je dodan. Uključite dnevni sync kada budete spremni.",
        "saveFailed": "Izvor nije moguće spremiti.",
        "invalidConfig": "Provjerite unesene podatke.",
        "syncNow": "Sinkroniziraj sada",
        "dailyEnabledLabel": "Dnevni sync uključen",
        "dailyEnabled": "Dnevni sync je uključen. Prvi sync je stavljen u red.",
        "dailyDisabled": "Dnevni sync je pauziran.",
        "nextRun": "Sljedeći sync",
        "syncDone": "Sinkronizirano: {{items}} proizvoda ({{used}}/{{allowed}} danas).",
        "syncQueued": "Sinkronizacija je stavljena u red ({{used}}/{{allowed}} danas).",
        "syncFailed": "Sinkronizacija nije uspjela.",
        "quotaSpent": "Dnevna kvota je potrošena ({{used}}/{{allowed}}). Pokušajte sutra ili nadogradite plan.",
        "history": "Povijest",
        "noRuns": "Još nema pokretanja.",
        "runsFailed": "Povijest nije moguće dohvatiti.",
        "delete": "Obriši",
        "deleted": "Izvor je obrisan.",
        "deleteFailed": "Izvor nije moguće obrisati.",
        "confirmDelete": "Obrisati izvor {{name}}? Katalog ostaje, ali se više neće osvježavati.",
        "items": "proizvoda",
        "waitingFirstRun": "Čeka prvu sinkronizaciju",
        "loadFailed": "Izvore trenutno nije moguće dohvatiti.",
        "limitsNote": "Plan: do {{perDay}}× dnevno (danas iskorišteno {{used}}), do {{products}} proizvoda.",
        "draft": "Dnevni sync je pauziran. Možeš ga uključiti ispod ili pokrenuti ručno.",
        "scheduleActive": "Automatsko osvježavanje je uključeno",
        "schedulePaused": "Automatsko osvježavanje je isključeno",
        "progress": "Napredak kataloga",
        "progressHint": "Stvarni broj proizvoda po statusu; ažurira se svakih 10 sekundi.",
        "live": "Uživo · 10 s",
        "readCategories": "Očitaj kategorije",
        "reviewCategories": "Mapiranja kategorija",
        "progressLabels": {
            "published": "U katalogu",
            "waiting": "Čeka obradu",
            "queued": "U redu",
            "running": "Obrađuje se",
            "review": "Za pregled",
            "failed": "Neuspjelo"
        },
        "status_ok": "U redu",
        "status_partial": "Djelomično",
        "status_failed": "Neuspjelo",
        "status_timeout": "Isteklo vrijeme",
        "status_running": "U tijeku",
        "status_skipped": "Preskočeno",
        "status_never": "Nije pokrenuto",
        "outcome_created": "Novi proizvodi",
        "outcome_price_updated": "Promijenjena cijena",
        "outcome_stock_updated": "Promijenjena zaliha",
        "outcome_url_updated": "Promijenjen link",
        "outcome_discount_created": "Nova akcija",
        "outcome_discount_updated": "Ažurirana akcija",
        "outcome_delisted": "Ukinuto s ponude",
        "outcome_reactivated": "Vraćeno u ponudu",
        "outcome_unchanged": "Nepromijenjeno",
        "outcome_filtered": "Filtrirano pravilima"
    },
    "Plan": {
        "privateOffer": "Posebna cijena",
        "title": "Moj plan",
        "currentPlan": "Trenutni plan",
        "free": "Besplatno",
        "perMonth": "mj",
        "perYear": "god",
        "unlimited": "Neograničeno",
        "included": "Uključeno",
        "notIncluded": "Nije uključeno",
        "renewsOn": "Obnavlja se",
        "upgradeTo": "Sljedeći plan",
        "choosePlan": "Odaberi plan",
        "upgrade": "Nadogradi",
        "changePlan": "Promijeni plan",
        "differentLimits": "Ovaj plan ima drukčije limite. Usporedi ih ispod prije promjene.",
        "compareBelow": "Cijenu i limite odabranog plana možeš usporediti s trenutnim ispod.",
        "paymentUnavailable": "Online plaćanje plana nije podešeno. Obratite se podršci.",
        "paymentStarting": "Pokretanje plaćanja...",
        "paymentFailed": "Plaćanje nije uspjelo.",
        "paymentNotConfirmed": "Plaćanje još nije potvrđeno. Provjerite stranicu naplate prije ponovnog pokušaja.",
        "paymentReceived": "Plaćanje je zaprimljeno. Plan se upravo ažurira.",
        "paymentActivationPending": "Plaćanje je potvrđeno. Aktivacija plana još traje; osvježite stranicu za trenutak.",
        "existingStripeSubscription": "Promjena aktivnog Stripe plana još nije dostupna samostalno. Obratite se podršci.",
        "usageTitle": "Potrošnja",
        "usageSubtitle": "Pogledaj koliko koristiš i kako se limiti razlikuju po planovima.",
        "currentLimit": "Tvoj limit",
        "featuresTitle": "Uključene mogućnosti",
        "entitlement": "Pravo",
        "used": "Iskorišteno",
        "limit": "Limit",
        "usageShare": "Udio",
        "liveNote": "Proizvodi, lokacije i loyalty članovi broje se iz trenutnog stanja.",
        "loadFailed": "Podatke o planu trenutno nije moguće dohvatiti."
    },
    "Stats": {
        "title": "Statistika prikaza",
        "loading": "Učitavanje…",
        "loadFailed": "Statistiku trenutno nije moguće dohvatiti.",
        "noData": "Za odabrano razdoblje nema zabilježenih prikaza.",
        "backendUpdateRequired": "Detaljan graf će biti dostupan nakon ažuriranja backenda.",
        "rangeLabel": "Razdoblje",
        "granularityLabel": "Prikaz po",
        "range_7": "Zadnjih 7 dana",
        "range_30": "Zadnjih 30 dana",
        "range_90": "Zadnjih 90 dana",
        "range_365": "Zadnjih 12 mjeseci",
        "byDay": "Dnevno",
        "byWeek": "Tjedno",
        "byMonth": "Mjesečno",
        "viewed": "Pregledi",
        "clicks": "Odlazak trgovcu",
        "impressions": "Prikazi",
        "detailViews": "Otvaranja detalja",
        "discountImpressions": "Prikazi popusta",
        "discountDetailViews": "Otvaranja detalja popusta",
        "discountClicks": "Odlazak na stranicu trgovca",
        "catalogImpressions": "Prikazi kataloških proizvoda",
        "catalogDetailViews": "Otvaranja detalja kataloških proizvoda",
        "catalogClicks": "Odlazak na stranicu trgovca",
        "clickRate": "Stopa odlaska trgovcu",
        "discountClickRate": "Stopa odlaska na stranicu trgovca",
        "reach": "Doseg ovaj mjesec",
        "chartTitle": "Prikazi, otvaranja detalja i klikovi kroz vrijeme",
        "chartDiscountTitle": "Angažman na popustima",
        "chartCatalogTitle": "Angažman na katalogu",
        "chartNote": "Prikaz se bilježi kada je kartica vidljiva, otvaranje kada korisnik otvori detalje, a odlazak kada ode na ponudu trgovca. Aplikacija i web izlog su objedinjeni. Stariji web podaci imali su objedinjene prikaze i otvaranja te su uključeni u historijski broj prikaza.",
        "surfaceApp": "Aplikacija",
        "surfaceStorefront": "Web izlog",
        "topItems": "Najangažovanije ponude",
        "product": "Proizvod"
    },
    "PartnerReferral": {
        "title": "Partner preporuka",
        "heading": "Kod partnera koji vas je preporučio",
        "description": "Unesite referral kod partnera koji je preporučio DigiWarranty vašoj firmi. Kod se veže za organizaciju i može se promijeniti prije prve evidentirane plaćene pretplate.",
        "codeLabel": "Referral kod",
        "save": "Spremi kod",
        "saved": "Partner preporuka je spremljena.",
        "locked": "Preporuka je zaključana od {date}, nakon prve plaćene pretplate.",
        "terms": "Referral kod nije kod za popust. Provizija partnera nastaje tek nakon uspješne uplate pretplate. Bez referral koda partner se ne evidentira.",
        "loadError": "Postavke preporuke nije moguće učitati.",
        "saveError": "Referral kod nije moguće spremiti. Provjerite kod i pokušajte ponovo."
    },
    "PartnerDashboard": {
        "loading": "Učitavanje partnerskog prostora…",
        "loadError": "Partnerski prostor nije moguće učitati.",
        "retry": "Pokušaj ponovo",
        "dashboardTitle": "Partnerska nadzorna ploča",
        "partnerProgram": "Prostor za prodajne partnere",
        "welcome": "Dobro došli, {{name}}",
        "overviewIntro": "Pratite trgovce koje ste preporučili, status njihovih pretplata i svoje provizije.",
        "referralCode": "Vaš referral kod",
        "copyCode": "Kopiraj kod",
        "copied": "Referral kod je kopiran.",
        "copyError": "Kod nije moguće kopirati. Označite ga i kopirajte ručno.",
        "referredRetailers": "Preporučeni trgovci",
        "referredRetailersHint": "Organizacije povezane s vašim partnerskim profilom",
        "activeSubscriptions": "Aktivne pretplate",
        "activeSubscriptionsHint": "Trgovci s aktivnom plaćenom pretplatom",
        "installations": "Instalacije dodatka",
        "installationsHint": "Praćene instalacije preporučenih trgovaca",
        "pendingCommission": "Provizija na čekanju",
        "paidCommission": "Isplaćena provizija",
        "reversalDue": "Korekcija povrata",
        "reversalDueAmount": "Provizija za povrat",
        "noCommission": "Još nema provizije",
        "noReversal": "Nema korekcija za podmiriti",
        "commissionRate": "{{rate}}% ponavljajuće provizije",
        "commissionExplanation": "Provizija se evidentira nakon uspješne uplate trgovca. Besplatni računi i neplaćeni probni periodi ne donose proviziju; povrat može umanjiti ili poništiti iznos.",
        "payoutSetupTitle": "Podaci za isplatu",
        "payoutSetupText": "Dodajte kontaktni email za dogovor oko isplata partnerima.",
        "managePayout": "Uredi postavke isplate",
        "retailersTitle": "Trgovci",
        "installationsTitle": "Instalacije dodatka",
        "commissionsTitle": "Provizije",
        "teamTitle": "Članovi tima",
        "teamReadOnly": "Možete pregledati partnerski tim, ali samo administratori organizacije mogu dodavati ili uklanjati članove.",
        "settingsTitle": "Partnerske postavke",
        "payoutTitle": "Kontakt za isplatu",
        "payoutDescription": "Postavite email za dogovor oko partnerskih isplata. Podaci za plaćanje dogovaraju se zasebno s DigiWarranty timom.",
        "commissionRateLabel": "Stopa provizije",
        "accountStatus": "Status partnera",
        "payoutEmail": "Kontaktni email za isplatu",
        "payoutEmailPlaceholder": "isplate@example.com",
        "payoutEmailHelp": "Postavke isplate vide i mijenjaju samo administratori partnerske organizacije.",
        "adminOnlySettings": "Postavke isplate dostupne su administratorima partnerske organizacije.",
        "settingsSaved": "Kontakt za isplatu je spremljen.",
        "saveError": "Postavke isplate nije moguće spremiti. Pokušajte ponovo.",
        "save": "Spremi",
        "saving": "Spremanje…",
        "addMemberTitle": "Dodaj člana tima",
        "addMemberText": "Kreirajte pristup za kolegu kojem treba ovaj partnerski prostor.",
        "firstName": "Ime",
        "lastName": "Prezime",
        "email": "Email",
        "temporaryPassword": "Početna lozinka",
        "temporaryPasswordHelp": "Početnu lozinku podijelite sigurnim kanalom. Član tima može koristiti oporavak računa ako je treba promijeniti.",
        "addMember": "Dodaj člana",
        "adding": "Dodavanje…",
        "memberAdded": "Član tima je dodan.",
        "memberAddError": "Člana tima nije moguće dodati.",
        "memberRemoved": "Pristup člana tima je uklonjen.",
        "memberRemoveError": "Pristup člana tima nije moguće ukloniti.",
        "removeConfirm": "Ukloniti ovog člana iz partnerske organizacije? Njegov DigiWarranty račun ostaje aktivan.",
        "remove": "Ukloni pristup",
        "actions": "Radnje",
        "name": "Ime",
        "added": "Dodano",
        "retailer": "Trgovac",
        "plan": "Paket",
        "subscriptionPayment": "Uplata pretplate",
        "refunded": "Vraćeno",
        "rate": "Stopa",
        "noPaidPlan": "Nema plaćenog paketa",
        "subscription": "Pretplata",
        "active": "Aktivna",
        "inactive": "Neaktivna",
        "account": "Račun",
        "periodEnd": "Završetak perioda",
        "platform": "Platforma",
        "store": "Trgovina",
        "version": "Verzija dodatka",
        "status": "Status",
        "lastSeen": "Zadnja aktivnost",
        "commission": "Provizija",
        "netCommission": "Provizija nakon povrata",
        "date": "Datum",
        "paidAt": "Isplaćeno",
        "statuses": {
            "active": "Aktivno",
            "approved": "Odobreno",
            "cancelled": "Otkazano",
            "connected": "Povezano",
            "inactive": "Neaktivno",
            "installed": "Instalirano",
            "onboarding": "Postavljanje u tijeku",
            "paid": "Plaćeno",
            "partially_refunded": "Djelomično vraćeno",
            "past_due": "Plaćanje kasni",
            "pending": "Na čekanju",
            "reversal_due": "Povrat provizije za podmiriti",
            "reversed": "Poništeno",
            "suspended": "Obustavljeno",
            "trialing": "Probno razdoblje",
            "uninstalled": "Deinstalirano"
        },
        "empty": "Još nema podataka za prikaz.",
        "results": "Rezultata: {{total}}",
        "page": "Stranica {{page}} od {{lastPage}}",
        "previous": "Prethodna stranica",
        "next": "Sljedeća stranica"
    },
    "PartnerNavigation": {
        "dashboard": "Pregled",
        "retailers": "Trgovci",
        "team": "Tim",
        "installations": "Instalacije",
        "commissions": "Provizije",
        "settings": "Postavke"
    },
    "CategoryMappings": {
        "title": "Mapiranje kategorija",
        "description": "Pregledajte kako se kategorije iz vaših feedova povezuju s Google Product Taxonomy. AI prijedlozi se provjeravaju prema našoj taksonomiji; potvrđena mapiranja ostaju nepromijenjena.",
        "sourceFilter": "Filtriraj izvor",
        "allSources": "Svi izvori",
        "refresh": "Osvježi",
        "total": "Ukupno kategorija",
        "confirmed": "Potvrđeno",
        "review": "Za mapiranje ili pregled",
        "source": "Izvor",
        "external": "Kategorija u vašem feedu",
        "externalId": "Vanjski ID",
        "target": "Google Product Taxonomy",
        "searchTaxonomy": "Pretražite naziv, putanju ili GPT kod",
        "status": "Status",
        "action": "Radnja",
        "save": "Spremi",
        "saving": "Spremam…",
        "saved": "Mapiranje je spremljeno.",
        "saveFailed": "Mapiranje nije moguće spremiti.",
        "aiAction": "AI mapiraj kategorije",
        "aiRunning": "AI mapiranje u tijeku…",
        "aiDone": "AI je obradio {{processed}} kategorija: {{confirmed}} potvrđeno, {{suggested}} prijedloga i {{needs_review}} za ručni pregled.",
        "aiFailed": "AI mapiranje nije uspjelo. Pokušajte ponovo.",
        "loadFailed": "Mapiranja kategorija nije moguće učitati.",
        "empty": "Još nema kategorija iz feedova za mapiranje.",
        "status_confirmed": "Potvrđeno",
        "status_suggested": "Prijedlog",
        "status_needs_review": "Potreban pregled",
        "status_pending": "Čeka mapiranje"
    },
    "Navigation": {
        "discoveryStats": "Statistika prikaza",
        "catalogSources": "Izvori kataloga",
        "categoryMappings": "Mapiranje kategorija",
        "plan": "Moj plan",
        "partnerReferral": "Partner preporuka",
        "delivery": "Dostava",
        "bestOffers": "Najbolje ponude",
        "billApprovals": "Odobrenja računa",
        "campaigns": "Kampanje",
        "crossSellEarnings": "Cross-sell zarada",
        "customers": "Kupci",
        "dashboard": "Nadzorna ploča",
        "discounts": "Popusti",
        "imports": "Uvozi",
        "items": "Stavke",
        "logout": "Odjava",
        "pos_integration": "Integracije trgovine",
        "products": "Proizvodi",
        "profile": "Profil",
        "repairServices": "Ovlašteni Servisi",
        "scannedBills": "Skenirani računi",
        "settings": "Postavke",
        "transactions": "Transakcije",
        "users": "Korisnici",
        "venues": "Mjesta",
        "warranties": "Garancije",
        "warranties_templates": "Predlošci Garancija"
    },
    "Next": "Next",
    "OrgUsers": {
        "addStaff": "Add Staff",
        "columns": {
            "createdAt": "Kreirano",
            "email": "Email",
            "name": "Ime",
            "role": "Uloga"
        },
        "createError": "Create Error",
        "createSuccess": "Create Success",
        "deleteConfirm": "Delete Confirm",
        "deleteError": "Delete Error",
        "deleteSuccess": "Delete Success",
        "editStaff": "Edit Staff",
        "email": "Email",
        "emailPlaceholder": "Enter email",
        "firstName": "First Name",
        "firstNamePlaceholder": "Enter first name",
        "lastName": "Last Name",
        "lastNamePlaceholder": "Enter last name",
        "leaveBlank": "Leave Blank",
        "password": "Password",
        "passwordPlaceholder": "Enter password",
        "passwordPlaceholderEdit": "Password Placeholder Edit",
        "passwordRequired": "Password Required",
        "requiredFields": "Required Fields",
        "role": "Role",
        "selectRole": "Select a role",
        "tabs": {
            "roles": "Roles & Permissions",
            "staff": "Staff Members"
        },
        "title": "Korisnici",
        "updateError": "Update Error",
        "updateSuccess": "Update Success"
    },
    "POSIntegration": {
        "apiDescription": "API za integraciju POS sustava s našom aplikacijom.",
        "apiKeyGenerated": "API ključ generiran",
        "apiTitle": "API za integraciju POS sustava",
        "generateApiKeySummary": "Generiraj API ključ",
        "importItemsSummary": "Uvezi stavke",
        "itemsImportedSuccessfully": "Stavke uspješno uvezene",
        "pageTitle": "Integracija POS-a"
    },
    "PhoneInput": {
        "placeholder": "Unesite broj telefona",
        "selectCountryCode": "Pozivni broj"
    },
    "ProductApprovalDetail": {
        "actions": {
            "approve": {
                "button": "Approve & Add to Catalog",
                "description": "Add this product to your official catalog. It will become available for warranty tracking.",
                "title": "Approve Product"
            },
            "merge": {
                "confirmButton": "Confirm Merge",
                "description": "Link this virtual product to an existing product in your catalog.",
                "searchButton": "Search Products",
                "searchPlaceholder": "Search by name or model...",
                "title": "Merge with Existing"
            },
            "reject": {
                "button": "Reject Product",
                "description": "This product will not be added to your catalog.",
                "title": "Reject Product"
            }
        },
        "alreadyApproved": "This product has been approved",
        "alreadyMerged": "This product has been merged",
        "alreadyRejected": "This product has been rejected",
        "approveSuccess": "Product approved and added to your catalog.",
        "back": "Back to approvals",
        "error": "Failed to load product.",
        "fields": {
            "brand": "Brand",
            "category": "Category",
            "model": "Model",
            "parentCategory": "Parent Category",
            "source": "Source",
            "submittedAt": "Submitted"
        },
        "loading": "Loading product...",
        "mergeSuccess": "Product merged successfully.",
        "mergedInto": "Merged into",
        "notFound": "Product not found.",
        "notesPlaceholder": "Add any notes about this review...",
        "processing": "Processing...",
        "rejectModal": {
            "cancel": "Cancel",
            "confirm": "Confirm Rejection",
            "description": "Please select a reason for rejecting this product.",
            "reasons": {
                "counterfeit": "Suspected counterfeit",
                "discontinued": "Discontinued product",
                "duplicate": "Duplicate entry",
                "incorrectInfo": "Incorrect information",
                "notOurProduct": "Not our product",
                "other": "Other reason"
            },
            "selectReason": "Select a reason...",
            "title": "Reject Product"
        },
        "rejectSuccess": "Product rejected.",
        "reviewedAt": "Reviewed at",
        "sections": {
            "actions": "Actions",
            "category": "Category",
            "description": "Description",
            "extractedData": "Extracted Data",
            "identifiers": "Product Identifiers",
            "productInfo": "Product Information",
            "reviewNotes": "Review Notes",
            "sourceInfo": "Source Information"
        },
        "source": {
            "scannedBill": "Scanned Bill"
        },
        "title": "Product Review",
        "viewMergedProduct": "View merged product",
        "virtualProduct": "Virtual Product"
    },
    "ProductApprovals": {
        "actions": {
            "review": "Review"
        },
        "columns": {
            "actions": "Actions",
            "category": "Category",
            "identifiers": "Identifiers",
            "image": "Image",
            "productName": "Product",
            "source": "Source",
            "status": "Status",
            "submittedAt": "Submitted"
        },
        "empty": {
            "description": "Virtual products from scanned bills will appear here for your approval.",
            "title": "No products to review"
        },
        "error": "Failed to load products.",
        "filters": {
            "all": "All",
            "status": "Status"
        },
        "loading": "Loading products...",
        "searchPlaceholder": "Search by product name, EAN, or model...",
        "source": {
            "scannedBill": "Scanned Bill"
        },
        "stats": {
            "approved": "Approved",
            "merged": "Merged",
            "pending": "Pending",
            "rejected": "Rejected"
        },
        "status": {
            "approved": "Approved",
            "merged": "Merged",
            "pending": "Pending",
            "rejected": "Rejected"
        },
        "subtitle": "Review virtual products submitted from scanned bills and approve them for your catalog.",
        "title": "Product Approvals"
    },
    "Products": {
        "Overview": {
            "actions": "Akcije",
            "availability": "Dostupnost",
            "available": "Dostupno",
            "category": "Kategorija",
            "manufacturer": "Proizvođač",
            "price": "Cijena",
            "product_name": "Naziv proizvoda",
            "sku": "SKU",
            "source": "Izvor",
            "stock": "Zaliha",
            "title": "Katalog proizvoda",
            "unavailable": "Nedostupno"
        },
        "SearchFilters": {
            "search_button": "Pretraži",
            "search_placeholder": "Pretraži po SKU, proizvodu ili proizvođaču",
            "select_category": "Odaberi kategoriju",
            "select_manufacturer": "Odaberi proizvođača"
        },
        "overview": "Pregled",
        "performance_insights": "Uvidi u performanse",
        "title": "Proizvodi"
    },
    "Profile": {
        "address": "Adresa",
        "city": "Grad",
        "country": "Država",
        "dateOfBirth": "Datum rođenja",
        "email": "Email",
        "female": "Žensko",
        "gender": "Spol",
        "male": "Muško",
        "name": "Ime",
        "phone": "Telefon",
        "save": "Spremi",
        "saveError": "Neuspješno ažuriranje profila. Pokušajte ponovo.",
        "saveSuccess": "Profil je uspješno ažuriran.",
        "saving": "Spremanje...",
        "selectCountry": "Odaberi državu",
        "selectGender": "Odaberi spol",
        "surname": "Prezime",
        "title": "Profil"
    },
    "Promotion Wizard": "Promotion Wizard",
    "Promotions Management": "Promotions Management",
    "QuestionModal": {
        "cancel": "Odustani",
        "email": "Email",
        "emailPlaceholder": "Unesite svoj email",
        "errors": {
            "emailRequired": "Email Required",
            "generic": "Molimo ispravite pogreške ispod.",
            "nameRequired": "Name Required",
            "questionRequired": "Pitanje je obavezno.",
            "submitFailed": "Submit Failed"
        },
        "explanation": "Molimo ispunite dolje navedene informacije.",
        "name": "Ime/Tvrtka",
        "namePlaceholder": "Unesite svoje ime ili naziv tvrtke",
        "question": "Pitanje",
        "questionPlaceholder": "Unesite svoje pitanje ovdje",
        "save": "Pošalji",
        "saving": "Šaljem...",
        "title": "Pošaljite svoje pitanje"
    },
    "RegisterPage": {
        "admin_email": "E-mail administratora",
        "admin_name": "Ime administratora",
        "admin_surname": "Prezime administratora",
        "back_to_login": "Povratak na prijavu",
        "company_name": "Naziv tvrtke",
        "company_type": "Tip tvrtke",
        "check_email_title": "Provjerite svoj e-mail",
        "check_email_message": "Poslali smo poveznicu za potvrdu na {{email}}. Otvorite je kako biste aktivirali račun tvrtke.",
        "verification_pending": "Čekamo potvrdu e-maila. Ova stranica automatski provjerava status svakih 20 sekundi.",
        "verification_checking": "Provjeravamo potvrdu e-maila…",
        "verification_approved": "E-mail je potvrđen i račun trgovca je aktivan. Sada se možete prijaviti.",
        "verification_review": "E-mail je potvrđen. DigiWarranty još treba pregledati račun.",
        "verification_rejected": "E-mail je potvrđen, ali s računom treba pomoć. Obratite se DigiWarranty podršci.",
        "verification_expired": "Ova veza je istekla. Ponovno pokrenite povezivanje trgovine.",
        "verification_unavailable": "Registraciju nije moguće pronaći. Obratite se DigiWarranty podršci.",
        "currency": "Valuta",
        "password": "Lozinka",
        "password_repeat": "Ponovite lozinku",
                "field_required": "Ovo polje je obavezno.",
        "fix_required": "Molimo ispunite sva obavezna polja.",
        "passwords_mismatch": "Lozinke se ne podudaraju.",
        "plugin_return_hint": "Nakon potvrde prijavite se i vratit ćemo vas na povezivanje s platformom {{platform}}.",
        "woocommerce_signup_note": "Račun trgovca otvara se na besplatnom planu. Mogućnosti nadogradnje možete pogledati kasnije na nadzornoj ploči. Prije izrade ključa za trgovinu možda ćete morati potvrditi e-mail i pričekati odobrenje računa.",
        "plan": "Odaberite plan za trgovca",
        "mostPopular": "Najpopularniji",
        "contactForPrice": "Na upit",
        "month": "mjesečno",
        "planFeatures": {
            "products": "{{count}} proizvoda",
            "unlimitedProducts": "Neograničen broj proizvoda",
            "venues": "{{count}} prodajnih mjesta",
            "unlimitedVenues": "Neograničen broj prodajnih mjesta",
            "syncs": "{{count}} sinkronizacija kataloga dnevno",
            "unlimitedSyncs": "Neograničeno sinkronizacija kataloga",
            "reach": "Doseg do {{count}} kupaca mjesečno",
            "unlimitedReach": "Neograničen mjesečni doseg",
            "loyaltyMembers": "{{count}} članova programa vjernosti",
            "unlimitedLoyaltyMembers": "Neograničen broj članova programa vjernosti",
            "analytics": "{{level}} analitika",
            "segmentation": "{{level}} segmentacija kupaca",
            "api": "{{level}} API pristup",
            "loyalty": "Program vjernosti",
            "campaigns": "Kampanje",
            "push": "Push obavijesti",
            "email": "E-mail obavijesti",
            "prioritySupport": "Prioritetna podrška"
        },
        "plan_required": "Odaberite plan za trgovca i pokušajte ponovno. Ako nema dostupnih planova, osvježite stranicu.",
        "registration_failed": "Registracija nije uspjela. Provjerite podatke i pokušajte ponovno.",
        "registering": "Registracija...",
        "select_currency": "Odaberite valutu",
        "select_required": "Molimo odaberite tip tvrtke i valutu.",
        "select_type": "Odaberite tip",
        "submit": "Registriraj",
        "subtitle": "Kreirajte poslovni račun u nekoliko minuta.",
        "title": "Registracija tvrtke"
    },
    "Requirement": "Requirement",
    "RetailerBestOffers": {
        "distributor": "Distributer",
        "distributorFilter": "Distributer",
        "empty": "Trenutno nema dostupnih ponuda.",
        "error": "Nije moguće učitati ponude distributera.",
        "manufacturer": "Proizvođač",
        "manufacturerFilter": "Proizvođač",
        "minDiscount": "Min %",
        "off": "popusta",
        "results": "rezultata",
        "searchPlaceholder": "Pretraži proizvode, proizvođače...",
        "sortBy": "Sortiraj po",
        "sortDate": "Datum završetka",
        "sortDiscount": "Popust",
        "sortName": "Naziv",
        "subtitle": "Pregledajte aktivne distributerske promocije za vaša mjesta. Iskoristite ih prije isteka.",
        "title": "Najbolje ponude od distributera",
        "validPeriod": "Razdoblje valjanosti",
        "validUntil": "Vrijedi do {{end}}",
        "youSave": "Ušteda"
    },
    "RetailerDiscounts": {
        "empty": "Još nema zabilježenih popusta.",
        "error": "Nije moguće učitati popuste.",
        "filterLabel": "Filtriraj popuste po statusu",
        "filters": {
            "all": "Svi"
        },
        "manageCatalog": "Upravljaj katalogom",
        "resultsCount": "Ukupno popusta: {{count}}",
        "status": {
            "active": "Aktivan",
            "expired": "Istekao",
            "upcoming": "Nadolazeći"
        },
        "subtitle": "Pratite buduće promocije, aktivne ponude i završene popuste na jednom mjestu.",
        "summary": {
            "active": "Aktivni",
            "expired": "Istekli",
            "upcoming": "Nadolazeći"
        },
        "tableTitle": "Pregled popusta",
        "table": {
            "clicks": "Klikovi",
            "discount": "Popust",
            "end": "Vrijedi do",
            "global": "Sva mjesta",
            "product": "Proizvod",
            "shows": "Prikazi",
            "status": "Status",
            "venue": "Prodajno mjesto",
            "views": "Pregledi"
        },
        "title": "Vaši popusti"
    },
    "RetailerDistributorDetail": {
        "activeDiscounts": "Active Discounts",
        "backToList": "Back to Distributors",
        "categories": "Categories",
        "categoriesList": "Categories",
        "description": "Description",
        "discountsTab": "Discounts",
        "distributorLabel": "Distributor",
        "email": "Email",
        "error": "Unable to load distributor details.",
        "infoTab": "Info",
        "manufacturer": "Manufacturer",
        "manufacturers": "Manufacturers",
        "manufacturersTab": "Manufacturers",
        "name": "Name",
        "noDiscounts": "No active discounts from this distributor.",
        "noManufacturers": "No manufacturers listed.",
        "off": "off",
        "searchDiscounts": "Search discounts...",
        "validPeriod": "Valid Period",
        "website": "Website",
        "youSave": "You save"
    },
    "RetailerDistributors": {
        "availableInfo": "Contact distributors to establish a business connection.",
        "empty": "No distributors connected yet.",
        "emptyAvailable": "No available distributors found.",
        "error": "Unable to load distributors.",
        "errorAvailable": "Unable to load available distributors.",
        "findNew": "Find New Distributors",
        "myDistributors": "My Distributors",
        "searchAvailablePlaceholder": "Search for new distributors...",
        "searchPlaceholder": "Search distributors...",
        "stats": {
            "activeDiscounts": "Active Discounts",
            "categories": "Categories Covered",
            "connected": "Connected Distributors"
        },
        "subtitle": "Manage your distributor connections",
        "table": {
            "categories": "Categories",
            "description": "Description",
            "discounts": "Active Discounts",
            "manufacturers": "Manufacturers",
            "name": "Name",
            "view": "View"
        },
        "title": "Distributors"
    },
    "Save Campaign": "Save Campaign",
    "ScannedBills": {
        "statuses": {
            "admin_review": "Čeka pregled administratora",
            "needs_review": "Treba pregled",
            "org_review": "Čeka organizaciju",
            "pending_retailer": "Čeka trgovca",
            "pending_upload": "Čeka prijenos",
            "processed": "Odobren",
            "recognized": "AI pročitao",
            "rejected": "Odbijen",
            "retailer_approved": "Trgovac odobrio",
            "retailer_rejected": "Trgovac odbio",
            "user_confirmed": "Kupac potvrdio"
        },
        "adminTitle": "Skenirani računi",
        "bulkAction": "Primijeni status",
        "columns": {
            "actions": "Akcije",
            "createdAt": "Kreirano",
            "organization": "Organizacija",
            "status": "Status",
            "total": "Ukupno",
            "user": "Korisnik"
        },
        "detailTitle": "Detalji skena",
        "error": "Neuspjelo učitavanje skenova.",
        "filters": {
            "all": "Sve",
            "status": "Status"
        },
        "itemsTitle": "Stavke",
        "loading": "Učitavanje skenova...",
        "matchManufacturerItem": "ID proizvoda",
        "matchOrganization": "ID organizacije",
        "matchVariant": "ID varijante",
        "matchVenue": "ID lokacije",
        "orgTitle": "Skenirani računi",
        "previewImages": "Slike",
        "reprocess": "Ponovno pokreni OCR",
        "review": "Pregled",
        "reviewNotes": "Dodaj napomene",
        "saveReview": "Spremi pregled",
        "stats": {
            "needsReview": "Treba pregled",
            "pending": "Na čekanju",
            "processed": "Obrađeno",
            "rejected": "Odbijeno",
            "total": "Ukupno skenova"
        },
        "view": "Pogledaj"
    },
    "Settings": {
        "Delivery": {
            "tab": "Dostava",
            "title": "Gdje dostavljate",
            "subtitle": "Vaši popusti se prikazuju korisnicima u državama u koje dostavljate. Dok ovo ne promijenite, vide ih samo korisnici u vašoj državi.",
            "scopes": {
                        "domestic": "Samo moja država",
                        "domesticNamed": "Samo {{country}}",
                        "countries": "Izabrane države",
                        "worldwide": "Cijeli svijet"
            },
            "scopeHints": {
                        "domestic": "Vaše ponude ostaju vidljive samo kod kuće.",
                        "countries": "Izaberite države u koje šaljete.",
                        "worldwide": "Vaše ponude vidi svatko, bilo gdje."
            },
            "quickGroups": "Brzo dodaj:",
            "groups": {
                        "exYu": "Ex-Yu",
                        "eu": "EU",
                        "eea": "EEA"
            },
            "continents": {
                        "Europe": "Europa",
                        "Asia": "Azija",
                        "Africa": "Afrika",
                        "Americas": "Amerike",
                        "Oceania": "Oceanija",
                        "Antarctic": "Antarktika",
                        "Other": "Ostalo"
            },
            "searchPlaceholder": "Potražite državu…",
            "noMatches": "Nijedna država ne odgovara upitu „{{term}}”.",
            "clearAll": "Očisti sve",
            "homeCountry": "Matična",
            "disclaimer": "Ovo je vaša izjava o tome gdje šaljete i ona odlučuje tko vidi vaše ponude. Ako dodate državu u koju zapravo ne dostavljate, tamošnji kupci će vidjeti cijene po kojima ne mogu kupiti.",
            "pickAtLeastOne": "Izaberite barem jednu državu ili odaberite drugu opciju dostave.",
            "save": "Spremi",
            "saving": "Spremanje…",
            "saved": "Postavke dostave su spremljene.",
            "saveFailed": "Postavke dostave nije moguće spremiti.",
            "loadFailed": "Postavke dostave nije moguće učitati."
        },
        "Billing": {
            "Tutorial": {
                "explanation_message": "Pregledajte i upravljajte načinima plaćanja vaše organizacije, postavkama automatske naplate, mjesečnim računima i fakturama.",
                "explanation_title": "Upravljanje naplatom",
                "title": "Upute za postavke naplate"
            },
            "amount": "Iznos",
            "autoPayment": "Automatska naplata",
            "autoPaymentError": "Neuspješno ažuriranje postavke automatske naplate",
            "autoPaymentSuccess": "Postavka automatske naplate uspješno ažurirana!",
            "billingEmail": "E-mail za naplatu",
            "billingEmailError": "Neuspjelo spremanje e-maila za naplatu",
            "billingEmailPlaceholder": "Unesite e-mail za naplatu",
            "billingEmailSaved": "E-mail za naplatu je spremljen.",
            "cardError": "Neuspjelo spremanje kartice",
            "cardSaved": "Kartica je spremljena.",
            "currentPaymentMethod": "Trenutni način plaćanja",
            "download": "Preuzmi",
            "enableAutoPayment": "Omogući automatsku naplatu",
            "enterCard": "Dodajte karticu za omogucavanje naplate.",
            "error": "Pogreška pri učitavanju podataka o naplati",
            "invoiceNumber": "Broj fakture",
            "invoices": "Fakture",
            "issuedDate": "Datum izdavanja",
            "loadingPaymentForm": "Ucitavanje obrasca za placanje...",
            "missingPublishableKey": "Nedostaje Stripe javni kljuc.",
            "monthlyBills": "Mjesečni računi",
            "noBills": "Nema dostupnih računa.",
            "noInvoices": "Nema dostupnih faktura.",
            "noPaymentMethod": "Nema registriranog načina plaćanja (Stripe integracija u tijeku)",
            "paymentMethod": "Način plaćanja",
            "period": "Razdoblje",
            "saveBillingEmail": "Spremi e-mail za naplatu",
            "saveCard": "Spremi karticu",
            "savingCard": "Spremam...",
            "setupIntentError": "Nije moguce pokrenuti postavljanje kartice",
            "status": "Status",
            "title": "Postavke naplate",
            "updatePaymentMethod": "Ažuriraj način plaćanja"
        },
        "Contracts": {
            "Tutorial": {
                "explanation_message": "Postavite financijske uvjete za svoju organizaciju, uključujući naknade za transakcije, obavijesti, pretplatu i provizije za unakrsnu prodaju, te pregledajte povijest ugovora.",
                "explanation_title": "Konfiguracija ugovora",
                "title": "Upute za postavke ugovora"
            },
            "active": "Aktivan",
            "contractActive": "Ugovor aktivan",
            "contractHistory": "Povijest ugovora",
            "contractTerms": "Uvjeti ugovora",
            "crossSellCommission": "Provizija za unakrsnu prodaju (%)",
            "crossSellCommissionPlaceholder": "npr., 10.00",
            "emailNotificationFee": "Naknada za obavijesti putem e-maila ($)",
            "emailNotificationFeePlaceholder": "npr., 0.05",
            "endDate": "Datum završetka",
            "error": "Pogreška pri učitavanju ugovora",
            "fixedTransactionFee": "Fiksna naknada za transakciju ($)",
            "fixedTransactionFeePlaceholder": "npr., 1.00",
            "inactive": "Neaktivan",
            "monthlySubscriptionFee": "Mjesečna naknada za pretplatu ($)",
            "monthlySubscriptionFeePlaceholder": "npr., 100.00",
            "noContracts": "Nema dostupnih ugovora.",
            "nonNegative": "Mora biti nenegativno",
            "ongoing": "U tijeku",
            "profitPercentageFee": "Naknada za transakciju (%)",
            "profitPercentageFeePlaceholder": "npr., 2.00",
            "promosFeePerDay": "Naknada za promocije po danu ($)",
            "promosFeePerDayPlaceholder": "npr., 1.50",
            "pushNotificationFee": "Naknada za push obavijesti ($)",
            "pushNotificationFeePlaceholder": "npr., 0.03",
            "question": "Pomoć",
            "saveContract": "Spremi ugovor",
            "saveError": "Neuspješno spremanje ugovora",
            "saveSuccess": "Ugovor uspješno spremljen!",
            "shareInitialPrice": "Podijeli početnu cijenu",
            "smsNotificationFee": "Naknada za obavijesti putem SMS-a ($)",
            "smsNotificationFeePlaceholder": "npr., 0.10",
            "startDate": "Datum početka",
            "startDateRequired": "Datum početka je obavezan",
            "status": "Status",
            "title": "Postavke ugovora",
            "tutorial": "Upute"
        },
        "General": {
            "Tutorial": {
                "explanation_message": "Postavite osnovne informacije svoje organizacije, preferencije lokalizacije, integracijske krajnje točke i postavke obavijesti.",
                "explanation_title": "Konfiguracija općih postavki",
                "title": "Upute za opće postavke"
            },
            "address": "Adresa",
            "addressPlaceholder": "Unesite adresu",
            "basicInfo": "Osnovne informacije",
            "country": "Drzava",
            "currency": "Valuta",
            "defaultItemApiEndpoint": "Zadani API krajnji točak stavke",
            "defaultItemApiEndpointPlaceholder": "npr., https://api.organizacija.com/stavke",
            "defaultItemEndpoint": "Zadani krajnji točak stavke",
            "defaultItemEndpointPlaceholder": "npr., https://www.organizacija.com/",
            "defaultUserParameter": "Zadani korisnički parametar",
            "defaultUserParameterPlaceholder": "npr., user_id",
            "description": "Opis",
            "descriptionPlaceholder": "Unesite opis",
            "email": "E-mail tvrtke",
            "emailPlaceholder": "Unesite e-mail tvrtke",
            "error": "Pogreška pri učitavanju općih postavki",
            "foundedDate": "Datum osnivanja",
            "integrationEndpoints": "Integracijski krajnji točki",
            "invalidEmail": "Nevažeća adresa e-pošte",
            "invalidNotificationPreferences": "Nevažeći format postavki obavijesti",
            "invalidUrl": "Mora biti valjani URL",
            "language": "Jezik",
            "localization": "Lokalizacija",
            "logo": "Logotip",
            "logoHint": "Učitajte kvadratni logo (npr. 256x256 ili 512x512) za najbolji prikaz.",
            "logoPreview": "Pregled logotipa",
            "logoUploadCta": "Promijeni logotip",
            "logoUploadError": "Učitavanje logotipa nije uspjelo.",
            "logoUploaded": "Logotip je učitan.",
            "logoUploading": "Učitavanje logotipa...",
            "name": "Naziv organizacije",
            "namePlaceholder": "Unesite naziv organizacije",
            "nameRequired": "Naziv organizacije je obavezan",
            "notificationEmail": "E-mail za obavijesti",
            "notificationEmailPlaceholder": "Unesite e-mail za obavijesti",
            "notificationPreferences": "Postavke obavijesti",
            "notificationPreferencesPlaceholder": "Unesite JSON postavke",
            "notifications": "Obavijesti",
            "orgType": "Tip organizacije",
            "phone": "Telefon",
            "phoneCountry": "Drzava telefona",
            "phonePlaceholder": "Unesite broj telefona",
            "taxId": "Porezni broj / OIB",
            "taxIdPlaceholder": "Unesite porezni broj tvrtke",
            "taxIdPending": "Ovo možete unijeti kasnije. Promijenjeni broj zahtijeva novu provjeru.",
            "taxIdVerified": "Porezni broj je potvrđen",
            "vatId": "PDV ID",
            "vatIdPlaceholder": "Unesite PDV ID ako je primjenjivo",
            "question": "Pomoć",
            "saveBasicInfo": "Ažuriraj osnovne informacije",
            "saveBasicInfoError": "Neuspješno spremanje osnovnih informacija",
            "saveBasicInfoSuccess": "Osnovne informacije uspješno spremljene!",
            "saveChanges": "Spremi promjene",
            "saveError": "Neuspješno spremanje postavki",
            "saveIntegrationEndpoints": "Ažuriraj postavke integracija",
            "saveIntegrationEndpointsError": "Neuspješno spremanje integracijskih krajnjih točaka",
            "saveIntegrationEndpointsSuccess": "Integracijski krajnji točki uspješno spremljeni!",
            "saveLocalization": "Ažuriraj postavke lokalizacije",
            "saveLocalizationError": "Neuspješno spremanje postavki lokalizacije",
            "saveLocalizationSuccess": "Postavke lokalizacije uspješno spremljene!",
            "saveNotifications": "Ažuriraj postavke obavijesti",
            "saveNotificationsError": "Neuspješno spremanje postavki obavijesti",
            "saveNotificationsSuccess": "Postavke obavijesti uspješno spremljene!",
            "saveSuccess": "Postavke su uspješno spremljene!",
            "selectCountry": "Odaberite drzavu",
            "selectCurrency": "Odaberite valutu",
            "selectLanguage": "Odaberite jezik",
            "selectTimezone": "Odaberite vremensku zonu",
            "selectType": "Odaberite tip",
            "sendEmailNotifications": "Slanje obavijesti putem e-maila",
            "sendPushNotifications": "Slanje obavijesti putem push notifikacija",
            "sendSmsNotifications": "Slanje obavijesti putem SMS-a",
            "timezone": "Vremenska zona",
            "title": "Opće postavke",
            "tutorial": "Upute",
            "uploadLogo": "Upload Logo",
            "website": "Web stranica",
            "websitePlaceholder": "Unesite web stranicu"
        },
        "Integrations": {
            "Tutorial": {
                "explanation_message": "Dodajte i upravljajte POS ili web integracijama te pregledajte povijest uvoza CSV-a za upravljanje inventarom.",
                "explanation_title": "Upravljanje integracijama",
                "title": "Upute za postavke integracija"
            },
            "actions": "Akcije",
            "activate": "Aktiviraj",
            "active": "Aktivno",
            "addIntegration": "Dodaj integraciju",
            "apiEndpoint": "API krajnja točka",
            "apiEndpointPlaceholder": "Unesite API krajnju točku",
            "csvUploadHistory": "Povijest uvoza CSV-a",
            "currentIntegrations": "Trenutne integracije",
            "daily": "Dnevno",
            "deactivate": "Deaktiviraj",
            "delete": "Delete Integration",
            "deleteConfirm": "Delete Confirm",
            "deleteError": "Delete Error",
            "deleteSuccess": "Delete Success",
            "deleteTitle": "Delete Title",
            "email": "E-mail",
            "emailPlaceholder": "Unesite kontakt e-mail",
            "endpoint": "Krajnja točka",
            "error": "Pogreška pri učitavanju integracija",
            "errors": "Pogreške",
            "fileName": "Naziv datoteke",
            "general": "Općenito",
            "hasErrors": "Has Errors",
            "hourly": "Svaki sat",
            "inactive": "Neaktivno",
            "invalidEmail": "Nevažeća adresa e-pošte",
            "invalidUrl": "Mora biti valjani URL",
            "name": "Naziv",
            "namePlaceholder": "npr., Square POS, Shopify",
            "nameRequired": "Naziv je obavezan",
            "noCsvUploads": "Nema zabilježenih uvoza CSV-a.",
            "noErrors": "Nema",
            "noIntegrations": "Nema konfiguriranih integracija.",
            "pos": "POS integracije",
            "processedAt": "Obrada završena",
            "realtime": "U stvarnom vremenu",
            "saveError": "Neuspješno spremanje integracije",
            "saveSuccess": "Integracija uspješno spremljena!",
            "status": "Status",
            "statusError": "Neuspješno ažuriranje statusa integracije",
            "statusSuccess": "Status integracije uspješno ažuriran!",
            "syncInterval": "Interval sinkronizacije",
            "title": "Postavke integracija",
            "venueId": "ID mjesta (opcionalno)",
            "venueIdPlaceholder": "Unesite ID mjesta",
            "apiKey": "API ključ",
            "noLogs": "Nema zabilježenih logova integracije.",
            "copiedToClipboard": "Kopirano u međuspremnik",
            "retailer": {
                "title": "Povezani shop pluginovi",
                "subtitle": "Pregledajte konekcije shopova i zadnju aktivnost sinkronizacije.",
                "tab": "Shop pluginovi",
                "refresh": "Osvježi konekcije",
                "summary": "Sažetak konekcija",
                "total": "Shopovi",
                "active": "Aktivno",
                "errors": "S greškom",
                "filter": "Filtriraj konekcije",
                "filters": { "all": "Sve", "woocommerce": "WooCommerce", "shopware": "Shopware", "shopify": "Shopify" },
                "loading": "Učitavanje konekcija shopova...",
                "loadError": "Nije moguće učitati konekcije shopova.",
                "retry": "Pokušaj ponovo",
                "empty": "Nijedan shop plugin nije povezan s ovom organizacijom.",
                "emptyFilter": "Nema konekcija za ovu platformu.",
                "store": "Shop",
                "connection": "Konekcija",
                "features": "Uključeni podaci",
                "frequency": "Raspored",
                "lastActivity": "Zadnja aktivnost",
                "lastError": "Zadnja greška",
                "products": "Proizvodi",
                "discounts": "Popusti",
                "checkout": "Naplata",
                "manual": "Ručno",
                "seen": "Povezano",
                "never": "Nikad",
                "none": "Nema",
                "status": { "active": "Aktivno", "inactive": "Neaktivno", "disconnected": "Odspojeno", "pending": "Na čekanju" },
                "createWooKey": "Izradi WooCommerce ključ",
                "createPlatformKey": "Izradi ključ integracije",
                "platform": "Platforma",
                "keyCreateHint": "Ovaj ključ namijenjen je jednoj instalaciji platforme {{platform}}. Veže se za trgovinu i prodajni kanal kada ga plugin potvrdi.",
                "connectionName": "Naziv konekcije",
                "venue": "Online poslovnica",
                "createKey": "Generiraj pristupne podatke",
                "creatingKey": "Generiranje...",
                "keyCreated": "Pristupni podaci izrađeni",
                "copyNow": "Sada kopirajte obje vrijednosti. API tajna prikazuje se samo jednom.",
                "apiKey": "API ključ",
                "apiSecret": "API tajna",
                "copyKey": "Kopiraj API ključ",
                "copySecret": "Kopiraj API tajnu",
                "keyCreateError": "Nije moguće izraditi pristupne podatke integracije. Provjerite administratorski pristup organizaciji i pokušajte ponovo.",
                "copyError": "Nije moguće kopirati pristupni podatak. Označite ga i kopirajte ručno.",
                "awaitingValidation": "Čeka potvrdu plugina",
                "actions": "Akcije",
                "revoke": "Opozovi",
                "confirmRevoke": "Opozvati neiskorišteni ključ integracije? Više neće moći povezati trgovinu.",
                "revokeError": "Nije moguće opozvati ključ integracije na čekanju.",
                "noVenues": "Prije generiranja ključa izradite online poslovnicu.",
                "loadingVenues": "Učitavanje online poslovnica..."
            }
        },
        "Points": {
            "Tutorial": {
                "explanation_message": "Postavite sustav bodova lojalnosti vaše organizacije, uključujući stope zarađivanja bodova za redovne i unakrsne kupnje, maksimalne bodove po transakciji i postavke iskupljenja.",
                "explanation_title": "Kon Facetiae: Konfiguracija bodova lojalnosti",
                "title": "Upute za postavke bodova"
            },
            "error": "Pogreška pri učitavanju postavki bodova",
            "loyaltyPoints": "Konfiguracija bodova lojalnosti",
            "maxPointsPerTransaction": "Maksimalni bodovi po transakciji",
            "maxPointsPerTransactionPlaceholder": "npr., 100.00",
            "nonNegative": "Mora biti nenegativno",
            "pointsPerCrossSellUnit": "Bodovi po jedinici unakrsne prodaje",
            "pointsPerCrossSellUnitPlaceholder": "npr., 0.1000",
            "pointsPerCurrencyUnit": "Bodovi po jedinici valute",
            "pointsPerCurrencyUnitPlaceholder": "npr., 1.0000",
            "question": "Pomoć",
            "redemptionRate": "Stopa iskupljenja",
            "redemptionRatePlaceholder": "npr., 0.0100",
            "saveError": "Neuspješno spremanje postavki bodova",
            "savePointsSettings": "Spremi postavke bodova",
            "saveSuccess": "Postavke bodova uspješno spremljene!",
            "title": "Postavke bodova",
            "tutorial": "Upute"
        },
        "RepairServices": {
            "Tutorial": {
                "explanation_message": "Pretražite servise za popravak po marki i kategoriji kako biste pronašli odgovarajuće pružatelje za vaše potrebe.",
                "explanation_title": "Kako koristiti servise za popravak",
                "title": "Uputstvo za servise za popravak"
            },
            "address": "Adresa",
            "brandRequired": "Marka je obavezna",
            "categoryRequired": "Kategorija je obavezna",
            "error": "Greška",
            "noRepairCompanies": "Nema pronađenih servisa za popravak",
            "phone": "Telefon",
            "question": "Postavi pitanje",
            "search": "Pretraži servise za popravak",
            "selectBrand": "Odaberi marku",
            "selectCategory": "Odaberi kategoriju",
            "serviceProvider": "Servisni pružatelj",
            "title": "Servisi za popravak",
            "tutorial": "Pogledaj uputstvo",
            "venueName": "Naziv lokacije"
        },
        "Security": {
            "generate": "Generiraj",
            "length": "Duljina lozinke",
            "lengthOption": "{{count}} znakova",
            "entropyHint": "{{bits}} bita entropije",
            "copy": "Kopiraj",
            "copied": "Lozinka je kopirana.",
            "copyFailed": "Kopiranje nije uspjelo. Označite i kopirajte ručno.",
            "nothingToCopy": "Nema što kopirati.",
            "reveal": "Prikaži lozinku",
            "hide": "Sakrij lozinku",
            "generatedAndCopied": "Lozinka je generirana i kopirana.",
            "generatedNotCopied": "Lozinka je generirana. Kopiranje nije uspjelo, kopirajte ručno.",
            "saveItSomewhere": "Spremite lozinku prije nego što potvrdite — poslije je više nećemo moći prikazati.",
            "Tutorial": {
                "explanation_message": "Upravljajte lozinkom i e-mailom za oporavak korisnika te konfigurirajte API postavke svoje organizacije.",
                "explanation_title": "Osigurajte svoj račun",
                "title": "Upute za sigurnosne postavke"
            },
            "apiActive": "API aktivan",
            "apiKey": "API ključ",
            "apiKeyError": "Neuspješno regeneriranje API ključa",
            "apiKeySuccess": "API ključ uspješno regeneriran!",
            "apiStatusError": "Neuspješno ažuriranje statusa API-ja",
            "apiStatusSuccess": "Status API-ja uspješno ažuriran!",
            "confirmPassword": "Potvrdite novu lozinku",
            "confirmPasswordPlaceholder": "Potvrdite novu lozinku",
            "currentPassword": "Trenutna lozinka",
            "currentPasswordPlaceholder": "Unesite trenutnu lozinku",
            "currentPasswordRequired": "Trenutna lozinka je obavezna",
            "error": "Pogreška pri učitavanju sigurnosnih postavki",
            "invalidEmail": "Nevažeća adresa e-pošte",
            "newPassword": "Nova lozinka",
            "newPasswordPlaceholder": "Unesite novu lozinku",
            "noApiKey": "Nema generiranog API ključa",
            "noOrganization": "Nema dostupnih podataka o organizaciji",
            "organizationApi": "API organizacije",
            "passwordMinLength": "Lozinka mora imati najmanje 8 znakova",
            "passwordsDoNotMatch": "Lozinke se ne podudaraju",
            "question": "Question",
            "recoveryEmail": "E-mail za oporavak",
            "recoveryEmailPlaceholder": "Unesite e-mail za oporavak",
            "regenerateApiKey": "Ponovno generiraj API ključ",
            "saveError": "Neuspješno ažuriranje sigurnosnih postavki",
            "saveSuccess": "Sigurnosne postavke uspješno ažurirane!",
            "title": "Sigurnosne postavke",
            "tutorial": "Tutorial",
            "updateUserSecurity": "Ažuriraj korisničku sigurnost",
            "userSecurity": "Korisnička sigurnost"
        },
        "Tutorial": {
            "explanation_message": "Upravljajte postavkama svoje organizacije, uključujući opće informacije, naplatu, sigurnost, integracije, ugovore i bodove lojalnosti.",
            "explanation_title": "Pregled",
            "title": "Upute za postavke"
        },
        "UserInfo": {
            "Tutorial": {
                "explanation_message": "Ažurirajte svoje osobne informacije i upravljajte korisnicima unutar svoje organizacije.",
                "explanation_title": "Upravljanje korisničkim informacijama",
                "title": "Upute za postavke korisničkih informacija"
            },
            "actions": "Akcije",
            "addUser": "Dodaj korisnika",
            "country": "Država",
            "email": "E-mail",
            "emailPlaceholder": "Unesite svoj e-mail",
            "error": "Pogreška pri učitavanju korisničkih informacija",
            "invalidEmail": "Nevažeća adresa e-pošte",
            "name": "Ime",
            "namePlaceholder": "Unesite svoje ime",
            "nameRequired": "Ime je obavezno",
            "noUsers": "Nema dostupnih korisnika organizacije.",
            "organizationUsers": "Korisnici organizacije",
            "personalInfo": "Osobne informacije",
            "phoneNumber": "Broj telefona",
            "phoneNumberPlaceholder": "Unesite svoj broj telefona",
            "remove": "Ukloni",
            "role": "Uloga",
            "saveError": "Neuspješno ažuriranje korisničkih informacija",
            "savePersonalInfo": "Spremi osobne informacije",
            "saveSuccess": "Korisničke informacije uspješno ažurirane!",
            "selectCountry": "Odaberite državu",
            "title": "Postavke korisničkih informacija"
        },
        "billing": "Naplata",
        "contracts": "Ugovori",
        "error": "Pogreška pri učitavanju podataka postavki",
        "general": "Općenito",
        "integrations": "Integracije",
        "loading": "Učitavanje...",
        "noOrganization": "Nema dostupnih podataka o organizaciji.",
        "points": "Postavke bodova",
        "security": "Sigurnost",
        "title": "Postavke",
        "userInfo": "Informacije o korisniku"
    },
    "Strategies": "Strategies",
    "Strategy Name": "Strategy Name",
    "Target Name": "Target Name",
    "Targets": "Targets",
    "Transactions": {
        "TransactionsOverview": {
            "columns": {
                "averagePrice": "Prosječna cijena",
                "averageRevenue": "Prosječni prihod",
                "date": "Datum",
                "totalPrice": "Ukupna cijena",
                "totalRevenue": "Ukupni prihod",
                "transactionCount": "Broj transakcija"
            },
            "distinctBuyers": "Različiti kupci",
            "distinctManufacturers": "Različiti proizvođači",
            "loading": "Učitavanje transakcija...",
            "noStatistics": "Nema dostupnih statistika transakcija.",
            "questionMessage": "Ako imate pitanja o transakcijama ili prikazanim podacima, kliknite ikonu upitnika kako biste poslali svoje pitanje.",
            "questionTitle": "Imate pitanja?",
            "totalPrice": "Ukupna cijena",
            "totalRevenue": "Ukupni prihod",
            "totalTransactions": "Ukupan broj transakcija"
        },
        "TransactionsProgress": {
            "ageGroups": "Dobne skupine",
            "cityDistribution": "Raspodjela prema gradovima",
            "countryDistribution": "Raspodjela prema državama",
            "currentPeriod": "Trenutno razdoblje",
            "demographics": "Demografija",
            "distinctBuyerCount": "Različiti broj kupaca",
            "distinctManufacturers": "Različiti proizvođači",
            "error": "Greška pri dohvaćanju podataka o napretku: {{error}}",
            "genderDistribution": "Raspodjela prema spolu",
            "loading": "Učitavanje...",
            "previousPeriod": "Prethodno razdoblje",
            "residentialCountryDistribution": "Raspodjela prema državama prebivališta",
            "showingDataFor": "Prikaz podataka za: {{period}}",
            "title": "Napredak transakcija",
            "totalPrice": "Ukupna cijena",
            "totalRevenue": "Ukupni prihod",
            "totalTransactions": "Ukupan broj transakcija",
            "totals": "Zbrojevi"
        },
        "TransactionsStatistics": {
            "ageGroupDistribution": "Raspodjela dobnih skupina",
            "cityDistribution": "Raspodjela po gradovima",
            "countryDistribution": "Raspodjela po zemljama",
            "error": "Greška pri učitavanju demografskih podataka: {{error}}",
            "genderDistribution": "Raspodjela spola",
            "loading": "Učitavanje demografskih podataka...",
            "questionMessage": "Ako imate pitanja o demografiji ili prikazanim podacima, kliknite ikonu upitnika kako biste poslali svoje pitanje.",
            "questionTitle": "Imate pitanja?",
            "residentialCountryDistribution": "Raspodjela po rezidencijalnim zemljama",
            "title": "Demografija transakcija"
        },
        "Tutorial": {
            "customization_message": "Sve ove značajke mogu se prilagoditi i obogatiti dodatnim značajkama poput filtriranja i ciljanje.",
            "customization_title": "Prilagodba",
            "overview_tab_message": "Prva Pregledna kartica prikazuje transakcije grupirane prema datumu i sažetak tog razdoblja u zaglavljima.",
            "overview_tab_title": "Pregledna kartica",
            "period_selection_message": "Možete odabrati razdoblje za detalje koji se prikazuju u desnom kutu stranice. Odabrano razdoblje dijeli se u svakoj kartici koju odaberete.",
            "period_selection_title": "Odabir razdoblja",
            "progress_tab_message": "Treća kartica prikazuje usporedbu odabranog razdoblja. Na primjer, ako je odabrano 'Jučer', uspoređuje podatke s danom prije jučer. Ako je odabrano 'Prošli tjedan', uspoređuje podatke s prethodnim tjednom, a slično za 'Ovaj mjesec', 'Ovo tromjesečje' i 'Ovu godinu.'",
            "progress_tab_title": "Napredak kartica",
            "statistics_tab_message": "Druga kartica prikazuje demografske podatke korisnika i interakcije s organizacijom, poput spolova, zemalja u kojima su kupljene stavke, zemalja iz kojih potječu korisnici, dobnih skupina korisnika i gradova.",
            "statistics_tab_title": "Statistika kartica",
            "title": "Upute za transakcije",
            "welcome_message": "Dobrodošli u upute za transakcije! Evo što trebate znati."
        },
        "loading": "Učitavanje transakcija...",
        "noTransactions": "Nema dostupnih transakcija.",
        "overview": "Pregled",
        "progress": "Napredak",
        "statistics": "Statistika",
        "title": "Transakcije"
    },
    "Type": "Type",
    "Update": "Update",
    "UserInfoModal": {
        "cancel": "Odustani",
        "email": "Email",
        "emailPlaceholder": "Unesite svoj email",
        "errors": {
            "emailRequired": "Email je obavezan.",
            "generic": "Molimo ispravite pogreške ispod.",
            "nameRequired": "Ime je obavezno."
        },
        "explanation": "Molimo unesite svoje ime/tvrtku i email. Vaš email će se koristiti samo za odgovaranje na pitanja koja imate o sustavu tijekom demo verzije.",
        "explanationSub": "Ako trenutno nemate pitanja ili niste sigurni hoćete li postavljati pitanja, možete ostaviti ova polja prazna.",
        "name": "Ime/Tvrtka",
        "namePlaceholder": "Unesite svoje ime ili naziv tvrtke",
        "save": "Spremi",
        "title": "Unesite svoje podatke"
    },
    "Users": {
        "Roles": {
            "addRole": "Add Role",
            "cannotDeleteSystem": "Cannot Delete System",
            "cannotDeleteWithUsers": "Cannot Delete With Users",
            "columns": {
                "name": "Name",
                "permissions": "Permissions",
                "type": "Type",
                "users": "Users"
            },
            "createError": "Create Error",
            "createRole": "Create Role",
            "createSuccess": "Create Success",
            "customRole": "Custom Role",
            "deleteConfirm": "Delete Confirm",
            "deleteError": "Delete Error",
            "deleteSuccess": "Delete Success",
            "description": "Description",
            "descriptionPlaceholder": "Description Placeholder",
            "editRole": "Edit Role",
            "loadError": "Load Error",
            "module": "Module",
            "modules": {
                "campaigns": "Campaigns",
                "customers": "Customers",
                "discounts": "Discounts",
                "integrations": "Integrations",
                "items": "Items",
                "products": "Products",
                "roles": "Roles",
                "settings": "Settings",
                "transactions": "Transactions",
                "users": "Users",
                "venues": "Venues",
                "warranties": "Warranties"
            },
            "nameRequired": "Name Required",
            "noRoles": "No Roles",
            "noRolesDescription": "No Roles Description",
            "permissions": {
                "delete": "Delete",
                "none": "None",
                "read": "Read",
                "write": "Write"
            },
            "permissionsTitle": "Permissions Title",
            "roleName": "Role Name",
            "roleNamePlaceholder": "Role Name Placeholder",
            "systemRole": "System Role",
            "title": "Title",
            "updateError": "Update Error",
            "updateSuccess": "Update Success"
        },
        "Timeline": {
            "avgGrowth": "Avg Growth",
            "chartTitle": "Chart Title",
            "customers": "Customers",
            "error": "Pogreška prilikom učitavanja podataka vremenske linije",
            "latestMonth": "Latest Month",
            "loading": "Učitavanje podataka vremenske linije...",
            "loadingChart": "Loading Chart",
            "newCustomers": "New Customers",
            "title": "Registracije kupaca po mjesecu",
            "totalCustomers": "Total Customers",
            "totalOverall": "Total Overall",
            "xAxisTitle": "Mjesec",
            "yAxisTitle": "Broj registracija"
        },
        "Tutorial": {
            "explanation_message": "Postoje dvije vrste korisnika unutar organizacija: korisnici registrirani putem svoje organizacije i korisnici registrirani putem drugih organizacija. Zbog strožih pravila privatnosti u punoj verziji, neka polja neće biti vidljiva za korisnike koji ne pripadaju organizaciji. Statistički pregledi mogu se prilagoditi prema potrebama organizacije, omogućujući im da odaberu koje informacije žele pratiti.",
            "explanation_title": "Pregled",
            "title": "Upute za korisnike"
        },
        "UserCreate": {
            "cancel": "Odustani",
            "country": "Država",
            "createSuccess": "Create Success",
            "email": "Email",
            "emailPlaceholder": "Email Placeholder",
            "errorAlert": "Molimo ispravite pogreške ispod.",
            "gender": "Spol",
            "loadError": "Load Error",
            "loading": "Loading",
            "name": "Ime",
            "namePlaceholder": "Name Placeholder",
            "personalId": "Osobna iskaznica",
            "phoneNumber": "Broj telefona",
            "save": "Spremi",
            "saveError": "Save Error",
            "saving": "Spremam...",
            "selectCountry": "Odaberite državu",
            "selectGender": "Odaberite spol",
            "surname": "Prezime",
            "surnamePlaceholder": "Surname Placeholder",
            "title": "Dodaj kupca",
            "update": "Update",
            "updateSuccess": "Update Success",
            "validationError": "Validation Error"
        },
        "UserStatistics": {
            "global": "Globalno",
            "items": "artikala",
            "loadError": "Load Error",
            "loading": "Učitavanje statistike...",
            "noData": "No Data",
            "noStatistics": "Nema dostupnih statistika.",
            "overviewTitle": "Pregled statistike",
            "own": "Vlastiti",
            "salesByCountry": {
                "title": "Prodaja po državama",
                "userCount": "{{userCount}} korisnika"
            },
            "topBuyersByItems": "Najbolji kupci po artiklima",
            "topBuyersByTotalSpent": "Najbolji kupci po ukupno potrošenom",
            "totalBuyers": "Ukupno kupaca",
            "totalBuyersGlobal": "Ukupno kupaca (globalno)",
            "totalBuyersOwn": "Ukupno kupaca (vlastitih)",
            "totalRevenueGlobal": "Ukupni prihodi (globalno)",
            "totalRevenueOwn": "Ukupni prihodi (vlastiti)"
        },
        "UsersList": {
            "addUserButton": "Dodaj kupca",
            "columns": {
                "countOfItems": "Broj artikala",
                "firstTransactionDate": "Datum prve transakcije",
                "lastTransactionDate": "Datum posljednje transakcije",
                "name": "Ime",
                "status": "Status",
                "totalSpent": "Ukupno potrošeno",
                "userId": "ID korisnika",
                "venuesCount": "Broj mjesta"
            },
            "deleteConfirm": "Delete Confirm",
            "deleteError": "Delete Error",
            "deleteSuccess": "Delete Success",
            "deleteTitle": "Delete Title",
            "editModalTitle": "Edit Modal Title",
            "globalUser": "Globalni kupac",
            "legend": "Legenda:",
            "loadError": "Load Error",
            "loading": "Učitavanje...",
            "modalTitle": "Dodaj kupca",
            "noCustomers": "No Customers",
            "noUsers": "Nema dostupnih kupaca.",
            "ownUser": "Vlastiti kupac",
            "searchPlaceholder": "Search Placeholder",
            "title": "Kupci"
        },
        "statistics": "Statistika",
        "timeline": "Vremenska linija",
        "title": "Kupci",
        "usersList": "Popis kupaca",
        "SalesByCountryCompare": {
            "noData": "No Data",
            "salesLabel": "Sales Label",
            "title": "Title",
            "usersLabel": "Users Label"
        }
    },
    "Value": "Value",
    "Venues": {
        "Tutorial": {
            "exploration_message": "Kliknite 'Uredi' na poslovnici kako biste vidjeli uvide i metrike koje možete pratiti.",
            "exploration_title": "Istražite uvid u poslovnice",
            "title": "Tutorial za Poslovnice",
            "venues_management_message": "Možete dodati, urediti ili izbrisati poslovnice prema potrebi.",
            "venues_management_title": "Upravljajte svojim poslovnicama",
            "welcome_message": "Dobrodošli u odjeljak za Poslovnice! Ovdje možete učinkovito upravljati svojim poslovnicama."
        },
        "VenueForm": {
            "address_label": "Adresa:",
            "address_placeholder": "Adresa poslovnice",
            "basic_info": "Osnovne informacije",
            "city_label": "Grad:",
            "city_placeholder": "Grad poslovnice",
            "country_label": "Zemlja:",
            "createSuccess": "Create Success",
            "description_label": "Opis:",
            "description_placeholder": "Opis poslovnice",
            "email_label": "Email:",
            "email_placeholder": "Email poslovnice",
            "errors": {
                "address_required": "Adresa je obavezna",
                "city_required": "Grad je obavezan",
                "country_required": "Zemlja je obavezna",
                "email_invalid": "Email nije valjan",
                "email_required": "Email je obavezan",
                "latitude_invalid": "Širina mora biti broj",
                "latitude_range": "Širina mora biti između -90 i 90",
                "longitude_invalid": "Dužina mora biti broj",
                "longitude_range": "Dužina mora biti između -180 i 180",
                "name_required": "Ime je obavezno",
                "phone_country_required": "Odaberite zemlju za telefon",
                "phone_required": "Telefon je obavezan",
                "website_invalid": "Unesite ispravnu web stranicu (npr. gsoft.hr)",
                "website_required": "Web stranica je obavezna"
            },
            "facebook_label": "Facebook:",
            "facebook_placeholder": "https://facebook.com/venue",
            "instagram_label": "Instagram:",
            "instagram_placeholder": "https://instagram.com/venue",
            "latitude_label": "Širina:",
            "latitude_placeholder": "Širina",
            "loadError": "Load Error",
            "loading": "Učitavanje poslovnice...",
            "location_details": "Detalji lokacije",
            "longitude_label": "Dužina:",
            "longitude_placeholder": "Dužina",
            "name_label": "Ime:",
            "name_placeholder": "Ime poslovnice",
            "phone_label": "Telefon:",
            "saveError": "Save Error",
            "save_button": "Spremi",
            "select_country": "Odaberite zemlju",
            "social_media": "Linkovi društvenih mreža",
            "title_Edit": "Edituj poslovnicu {{venueName}}",
            "title_create": "Kreiraj novu poslovnicu",
            "title_edit": "Edituj poslovnicu {{venueName}}",
            "twitter_label": "Twitter:",
            "twitter_placeholder": "https://twitter.com/venue",
            "updateSuccess": "Update Success",
            "validationError": "Validation Error",
            "website_label": "Web stranica:",
            "website_placeholder": "Web stranica poslovnice"
        },
        "VenueView": {
            "Tutorial": {
                "details_message": "Ova kartica pruža pregled trenutnih podataka o Poslovnici.",
                "details_title": "Zavičajna kartica",
                "edit_message": "Na ovoj kartici možete izmijeniti podatke o Poslovnici. Pazite da sačuvate svoje promjene.",
                "edit_title": "Uredi Kartica",
                "integration_message": "Ovaj dio omogućava vam generiranje API ključa i tajne. To će se koristiti ako želite integrirati svoj sustav s samo jednom Poslovnicom. Ako trebate integrirati cijeli sustav, provjerite odjeljak POS integracije.",
                "integration_title": "Integracija Kartica",
                "statistics_message": "Ova kartica prikazuje transakcije grupirane po danu za odabrano razdoblje u gornjem desnom kutu. Moći ćete preuzeti detaljnije transakcije kao CSV datoteku, što će biti omogućeno kasnije.",
                "statistics_title": "Statistika Kartica",
                "title": "Title"
            },
            "VenueDetails": {
                "address_label": "Adresa:",
                "city_label": "Grad:",
                "country_label": "Država:",
                "description_label": "Opis:",
                "email_label": "Email:",
                "facebook": "Facebook",
                "instagram": "Instagram",
                "latitude_label": "Geografska Širina:",
                "longitude_label": "Geografska Dužina:",
                "name_label": "Naziv:",
                "organization_label": "Organizacija:",
                "phone_label": "Telefon:",
                "social_media": "Linkovi Društvenih Mreža",
                "title": "Detalji Poslovnice",
                "twitter": "Twitter",
                "website_label": "Web Stranica:"
            },
            "VenueIntegration": {
                "api_integration": "API Integracija",
                "api_key": "API Ključ",
                "generate_secret": "Generiraj API Tajnu",
                "generated_secret": "API Tajna: {{secret}}",
                "secret_timer": "Tajna će nestati za {{seconds}} sekundi."
            },
            "VenueStatistics": {
                "average_price": "Prosječna Cijena",
                "average_revenue": "Prosječni Prihodi",
                "date": "Datum",
                "total_discount": "Ukupni Popust",
                "total_price": "Ukupna Cijena",
                "total_quantity": "Ukupna Količina",
                "total_revenue": "Ukupni Prihodi",
                "total_tax": "Ukupni Porez",
                "total_transactions": "Totallne Transakcije",
                "transaction_count": "Broj Transakcija"
            },
            "loading": "Loading",
            "tabs": {
                "details": "Detalji",
                "edit": "Uredi Poslovnicu",
                "integration": "Integracija",
                "statistics": "Statistika"
            },
            "title": "Poslovnica: {{name}}"
        },
        "add_new_button": "Dodaj novu",
        "columns": {
            "action": "Akcija",
            "address": "Adresa",
            "country": "Zemlja",
            "email": "Email",
            "id": "ID",
            "name": "Ime",
            "phone": "Telefon"
        },
        "deleteConfirm": "Delete Confirm",
        "deleteError": "Delete Error",
        "deleteSuccess": "Delete Success",
        "deleteTitle": "Delete Title",
        "loadError": "Load Error",
        "noData": "No Data",
        "overview": "Poslovnica Pregled",
        "search_placeholder": "Pretraži po imenu ili opisu",
        "title": "Poslovnice",
        "VenuesProgress": {
            "title": "Title"
        }
    },
    "Warranties": {
        "actions": "Akcije",
        "activationDate": "Datum Aktivacije",
        "activeWarranties": "Aktivna Jamstva",
        "buyer": "Kupac",
        "enterSerialNumber": "Unesite serijski broj za pretragu",
        "errors": {
            "fetchFailed": "Neuspjelo dohvaćanje detalja jamstva"
        },
        "expirationDate": "Datum Isteka",
        "issuer": "Izdavatelj",
        "item": "Proizvod",
        "loading": "Učitavanje...",
        "noWarranties": "Nema pronađenih jamstava",
        "of": "od",
        "question": "Postavi Pitanje",
        "rowsPerPage": "Redova po stranici",
        "searchWarranties": "Pretraži Jamstva",
        "serialNumber": "Serijski Broj",
        "status": "Status",
        "title": "Jamstva",
        "tutorial": "Upute",
        "tutorialContent": "Pregledajte i upravljajte aktivnim jamstvima za proizvode prodane od strane vaše organizacije.",
        "tutorialTitle": "Upute za Aktivna Jamstva",
        "viewItem": "Otvori artikl",
        "warrantiesOverview": "Pregled Jamstava",
        "warrantyTemplates": "Predlošci Jamstava"
    },
    "WarrantyTemplates": {
        "actions": "Akcije",
        "active": "Aktivno",
        "applicability": "Applicability",
        "applicabilityAll": "Svi",
        "applicabilityCategory": "Kategorija",
        "applicabilityId": "Odabir Primjenjivosti",
        "applicabilityManufacturer": "Proizvođač",
        "applicabilityManufacturerItem": "Proizvod Proizvođača",
        "applicabilityType": "Tip Primjenjivosti",
        "back": "Back",
        "cancel": "Otkaži",
        "category": "Kategorija",
        "claimProcess": "Proces Zahtjeva (JSON)",
        "create": "Kreiraj Predložak",
        "createTitle": "Kreiraj Predložak Jamstva",
        "delete": "Obriši",
        "deleteConfirm": "Jeste li sigurni da želite obrisati predložak \"{name}\"? Ova akcija se ne može poništiti.",
        "deleteTitle": "Obriši Predložak",
        "description": "Opis",
        "detailsTitle": "Details Title",
        "duration": "Duration",
        "durationMonths": "Trajanje (Mjeseci)",
        "edit": "Uredi",
        "editTitle": "Uredi Predložak Jamstva",
        "errors": {
            "applicabilityIdRequired": "Odabir primjenjivosti je obavezan",
            "applicabilityTypeRequired": "Tip primjenjivosti je obavezan",
            "categoryRequired": "Kategorija je obavezna",
            "createFailed": "Neuspjelo kreiranje predloška",
            "deleteFailed": "Neuspjelo brisanje predloška",
            "durationInvalid": "Trajanje mora biti pozitivan broj",
            "fetchFailed": "Neuspjelo dohvaćanje detalja predloška",
            "invalidJson": "Nevaljan JSON format",
            "nameRequired": "Naziv je obavezan",
            "typeRequired": "Tip predloška je obavezan",
            "updateFailed": "Neuspjelo ažuriranje predloška"
        },
        "filterCategory": "Filtriraj po Kategoriji",
        "filterType": "Filtriraj po Tipu",
        "inactive": "Neaktivno",
        "isActive": "Aktivno",
        "loading": "Učitavanje...",
        "manufacturerItemId": "Manufacturer Item Id",
        "manufacturerItemName": "Manufacturer Item Name",
        "name": "Naziv",
        "noTemplates": "Nema pronađenih predložaka jamstava",
        "noVersions": "No Versions",
        "of": "od",
        "question": "Postavi Pitanje",
        "rowsPerPage": "Redova po stranici",
        "searchPlaceholder": "Pretraži po nazivu predloška",
        "status": "Status",
        "submit": "Pošalji",
        "terms": "Uvjeti (JSON)",
        "title": "Predlošci Jamstava",
        "tutorial": "Upute",
        "tutorialContent": "Upravljajte predlošcima jamstava za vašu organizaciju preprodavača. Kreirajte, uredite ili obrišite predloške za primjenu jamstava na prodane proizvode.",
        "tutorialTitle": "Upute za Predloške Jamstava",
        "type": "Tip",
        "updated": "Updated",
        "version": "Version",
        "versions": "Versions"
    },
    "common": {
        "active": "Aktivno",
        "cancel": "Odustani",
        "create": "Create",
        "delete": "Izbriši",
        "edit": "Uredi",
        "inactive": "Neaktivno",
        "loading": "Učitavanje…",
        "next": "Sljedeće",
        "none": "Nema",
        "previous": "Prethodno",
        "save": "Spremi",
        "saving": "Saving",
        "select": "Odaberi…",
        "unknown": "Unknown",
        "update": "Update"
    },
    "forgotPasswordPage": {
        "back_to_login": "Povratak na prijavu",
        "code_label": "Sesteroznamenkasti kod",
        "code_sent": "Ako racun postoji, poslali smo sesteroznamenkasti kod na unesenu adresu.",
        "email_label": "Email adresa",
        "instructions": "Unesite email adresu i poslat cemo vam kod za postavljanje nove lozinke.",
        "loading": "Slanje...",
        "password_changed": "Lozinka je promijenjena. Sada se mozete prijaviti.",
        "password_confirmation_label": "Potvrdite novu lozinku",
        "password_label": "Nova lozinka",
        "password_mismatch": "Lozinke se ne podudaraju.",
        "reset_button": "Postavi novu lozinku",
        "reset_instructions": "Unesite sesteroznamenkasti kod iz emaila i odaberite novu lozinku.",
        "reset_link_error": "Slanje linka nije uspjelo. Pokušajte ponovno.",
        "reset_link_sent": "Link za ponovno postavljanje je poslan na vaš email!",
        "submit_button": "Pošalji link",
        "title": "Zaboravljena lozinka"
    },
    "loading": "Loading",
    "AdminCategoryMapper": {
        "actions": {
            "saveAll": "Save All",
            "saveRow": "Save Row"
        },
        "codeLabel": "Code Label",
        "columns": {
            "gpc": "Gpc"
        },
        "filters": {
            "level": "Level",
            "unmappedOnly": "Unmapped Only"
        },
        "levelLabel": "Level Label",
        "loadError": "Load Error",
        "loading": "Loading",
        "pageTitle": "Page Title",
        "placeholders": {
            "searchGpc": "Search Gpc"
        },
        "searchSourceLabel": "Search Source Label"
    },
    "AdminOrganizations": {
        "actions": {
            "add": "Add",
            "create": "Create"
        },
        "columns": {
            "actions": "Actions",
            "active": "Active",
            "country": "Country",
            "email": "Email",
            "name": "Name",
            "type": "Type"
        },
        "empty": "Empty",
        "errors": {
            "load": "Load"
        },
        "filters": {
            "allTypes": "All Types",
            "searchPlaceholder": "Search Placeholder"
        },
        "form": {
            "organizationType": "Organization Type"
        },
        "loading": "Loading",
        "modal": {
            "addTitle": "Add Title",
            "editTitle": "Edit Title"
        },
        "stats": {
            "total": "Total"
        },
        "title": "Title"
    },
    "AdminPromotionTypes": {
        "actions": {
            "addEntity": "Add Entity",
            "deleteSelected": "Delete Selected",
            "editSelected": "Edit Selected"
        },
        "attributeModal": {
            "addTitle": "Add Title",
            "dataTypePlaceholder": "Data Type Placeholder",
            "editTitle": "Edit Title",
            "functionalityOptional": "Functionality Optional",
            "save": "Save",
            "supportedOperatorsPlaceholder": "Supported Operators Placeholder"
        },
        "attributes": {
            "add": "Add",
            "empty": "Empty",
            "loading": "Loading",
            "selectTypeHint": "Select Type Hint",
            "title": "Title"
        },
        "columns": {
            "attributes": "Attributes",
            "dataType": "Data Type",
            "operators": "Operators",
            "targetModel": "Target Model"
        },
        "deleteModal": {
            "body": "Body",
            "title": "Title"
        },
        "loadError": "Load Error",
        "loading": "Loading",
        "pageTitle": "Page Title",
        "typeModal": {
            "addTitle": "Add Title",
            "editTitle": "Edit Title",
            "targetModelOptional": "Target Model Optional"
        }
    },
    "AdminScannedBills": {
        "detail": {
            "adminNotesOptional": "Admin Notes Optional",
            "ai": {
                "analyzing": "Analyzing",
                "extractedBanner": "Extracted Banner",
                "forceRerun": "Force Rerun",
                "runAnalysis": "Run Analysis"
            },
            "cachedAt": "Cached At",
            "createNewVirtual": "Create New Virtual",
            "createVirtualOrganizationDesc": "Ovog trgovca nema u bazi. Stvara se virtualni zapis, koji stvarni račun kasnije može preuzeti.",
            "createVirtualVenueDesc": "Ovu poslovnicu nema u bazi. Stvara se virtualni zapis pod trgovcem.",
            "linkToExisting": "Link To Existing",
            "notSelected": "Not Selected",
            "pageTitle": "Page Title",
            "placeholders": {
                "adminNotes": "Admin Notes",
                "createManufacturer": "Create Manufacturer",
                "createProduct": "Create Product",
                "organizationName": "Organization Name",
                "searchOrCreateManufacturer": "Search Or Create Manufacturer",
                "searchOrganizations": "Search Organizations",
                "searchProducts": "Search Products",
                "searchVenues": "Search Venues",
                "venueName": "Venue Name"
            },
            "possibleMatches": "Possible Matches",
            "processing": {
                "allVirtualDesc": "Ni trgovac ni proizvođač još ne postoje kao stvarni računi, pa nitko ovo ne mora potvrditi. Račun nastaje odmah i kupac dobiva garanciju.",
                "allVirtualTitle": "Prolazi bez ičijeg odobrenja",
                "manufacturerVerificationSuffix": "Manufacturer Verification Suffix",
                "needsManufacturerApproval": "Needs Manufacturer Approval",
                "processBill": "Process Bill",
                "processing": "Processing",
                "productsCount": "Products Count",
                "realNeedsApproval": "Real Needs Approval",
                "retailerQueueDesc": "Trgovac je stvaran račun, pa se račun šalje njemu na potvrdu prije nego garancija počne.",
                "retailerQueueTitle": "Čeka trgovca",
                "whatWillHappen": "What Will Happen",
                "willCreateVirtual": "Will Create Virtual"
            },
            "retailerSearchDesc": "Potraži postojećeg trgovca ili ga napravi iz onoga što piše na računu.",
            "sections": {
                "aiAnalysis": "Ai Analysis",
                "items": "Items",
                "processingSummary": "Processing Summary",
                "retailerOrganization": "Retailer Organization",
                "venue": "Venue"
            },
            "unknownItem": "Unknown Item",
            "venueSearchDesc": "Potraži postojeću poslovnicu ili je napravi iz adrese na računu."
        }
    },
    "AdminCities": {
        "title": "Gradovi",
        "loading": "Učitavanje gradova...",
        "empty": "Nema pronađenih gradova.",
        "errors": {
            "load": "Neuspješno učitavanje gradova."
        },
        "stats": {
            "total": "Ukupno gradova",
            "capitals": "Glavni gradovi",
            "countries": "Države"
        },
        "filters": {
            "searchPlaceholder": "Pretraži po gradu ili državi...",
            "allCountries": "Sve države",
            "allCities": "Svi gradovi",
            "capitalsOnly": "Samo glavni gradovi",
            "nonCapitals": "Gradovi koji nisu glavni"
        },
        "columns": {
            "name": "Naziv",
            "country": "Država",
            "coordinates": "Koordinate",
            "population": "Stanovništvo",
            "capital": "Glavni grad",
            "actions": "Akcije"
        },
        "actions": {
            "add": "Dodaj grad",
            "create": "Kreiraj grad"
        },
        "modal": {
            "addTitle": "Dodaj grad",
            "editTitle": "Uredi grad",
            "deleteTitle": "Obriši grad",
            "deleteConfirm": "Jeste li sigurni da želite obrisati {{name}}?"
        },
        "form": {
            "name": "Naziv grada",
            "selectCountry": "Odaberi državu",
            "latitude": "Geografska širina",
            "longitude": "Geografska dužina",
            "region": "Regija",
            "population": "Stanovništvo",
            "isCapital": "Glavni grad",
            "coordinatesHint": "Koristite decimalne koordinate (npr. 43.8563, 18.4131)."
        }
    },
    "AdminUsers": {
        "actions": {
            "addUser": "Add User",
            "approveTermination": "Potvrdi brisanje racuna",
            "createUser": "Create User",
            "refreshList": "Refresh List",
            "updateUser": "Update User"
        },
        "columns": {
            "actions": "Actions",
            "city": "City",
            "created": "Created",
            "defaultPassword": "Default Password",
            "email": "Email",
            "name": "Name",
            "phone": "Phone",
            "roles": "Roles",
            "terminationStatus": "Status brisanja"
        },
        "deleteModal": {
            "confirmPrefix": "Confirm Prefix",
            "description": "Description",
            "title": "Title"
        },
        "empty": "Empty",
        "errors": {
            "load": "Load"
        },
        "filters": {
            "allCountries": "All Countries",
            "allOrganizations": "All Organizations",
            "allRoles": "All Roles",
            "anyPasswordState": "Any Password State",
            "changedPassword": "Changed Password",
            "defaultPassword": "Default Password",
            "searchPlaceholder": "Search Placeholder"
        },
        "listTitle": "List Title",
        "loading": "Loading",
        "modal": {
            "additionalDetails": "Additional Details",
            "createTitle": "Create Title",
            "editTitle": "Edit Title",
            "phoneCountry": "Phone Country",
            "roles": "Roles",
            "selectOrganization": "Select Organization"
        },
        "stats": {
            "createNew": "Create New",
            "editingUser": "Editing User",
            "mode": "Mode",
            "totalUsers": "Total Users"
        },
        "termination": {
            "active": "Aktivan",
            "pending": "Zahtjev na cekanju",
            "modalTitle": "Potvrda brisanja racuna",
            "confirmPrefix": "Potvrdi brisanje racuna korisnika",
            "confirmDescription": "Ova radnja odmah brise korisnika. Slanje arhive racuna emailom je trenutno backend placeholder i bit ce implementirano naknadno."
        },
        "tabs": {
            "statistics": "Statistics",
            "users": "Users"
        },
        "title": "Title"
    },
    "CustomIntegratorPanel": {
        "actions": {
            "rotateCredentials": "Rotate Credentials"
        },
        "confirm": {
            "deleteWebhook": "Delete Webhook",
            "rotateCredentials": "Rotate Credentials"
        },
        "credentials": {
            "apiKey": "Api Key",
            "apiSecret": "Api Secret",
            "notGenerated": "Not Generated",
            "subtitle": "Subtitle",
            "title": "Title"
        },
        "docs": {
            "quickStart": "Quick Start",
            "viewFull": "View Full"
        },
        "errors": {
            "deleteWebhook": "Delete Webhook",
            "loadCredentials": "Load Credentials",
            "rotateCredentials": "Rotate Credentials",
            "saveWebhook": "Save Webhook",
            "testWebhook": "Test Webhook",
            "webhookTestFailedWithReason": "Webhook Test Failed With Reason"
        },
        "health": {
            "customersCreated": "Customers Created",
            "errors24h": "Errors24h",
            "logTypes": {
                "all": "All",
                "error": "Error",
                "request": "Request",
                "webhook": "Webhook"
            },
            "noActivity": "No Activity",
            "productsSynced": "Products Synced",
            "recentActivity": "Recent Activity",
            "subtitle": "Subtitle",
            "title": "Title",
            "transactionsProcessed": "Transactions Processed"
        },
        "security": {
            "body": "Body",
            "title": "Title"
        },
        "tabs": {
            "credentials": "Credentials",
            "healthMonitoring": "Health Monitoring",
            "webhooks": "Webhooks"
        },
        "toasts": {
            "copiedToClipboard": "Copied To Clipboard",
            "credentialsRotated": "Credentials Rotated",
            "updateIntegrationNow": "Update Integration Now",
            "webhookCreated": "Webhook Created",
            "webhookDeleted": "Webhook Deleted",
            "webhookTestSuccess": "Webhook Test Success",
            "webhookUpdated": "Webhook Updated"
        },
        "webhooks": {
            "actions": {
                "delete": "Delete",
                "edit": "Edit",
                "test": "Test"
            },
            "addWebhook": "Add Webhook",
            "emptySubtitle": "Empty Subtitle",
            "emptyTitle": "Empty Title",
            "meta": {
                "allEvents": "All Events",
                "events": "Events",
                "lastDelivery": "Last Delivery",
                "never": "Never",
                "successRate": "Success Rate"
            },
            "modal": {
                "createTitle": "Create Title",
                "editTitle": "Edit Title",
                "eventsToSubscribe": "Events To Subscribe",
                "saveWebhook": "Save Webhook",
                "webhookUrl": "Webhook Url",
                "webhookUrlPlaceholder": "Webhook Url Placeholder"
            },
            "title": "Title"
        }
    }
};
